// @ts-nocheck
/* ГОНКА STING / STING POYGASI - miniapp screens (механика 5-А).
   Built on the STING design system tokens/fonts/assets. Russian + Uzbek.
   Big, simple, one-screen-first. No emoji - line icons + lightning only.
   Replaces the generic loyalty reference. See APP-SPEC.md. */
import React from "react";
import { Icon } from "./icons";
import {
  BOT_USERNAME,
  REFERRAL,
  REFERRAL_REWARDS_VISIBLE,
  TEAM_BOOST_THRESHOLD,
  attemptsLabel,
  chancesLabel,
  playersLabel,
  teamBoostProgress,
  teamBoostThreshold,
} from "./promo";
import * as Snd from "./sound";
import * as J from "./juice";
import {
  CountdownDigits,
  LeaderboardTable,
  TimeLeftBar,
  fmtHms,
  fmtHhMmTashkent,
  minutesLeft,
  phaseOf,
  useNowTicker,
} from "./pitwindow";
import * as Hx from "./haptics";
const A = "/ds/assets/";
const VID = A + "f1/bg-video.webm";
const POSTER = A + "f1/bg-poster.webp";
const PRODUCT_CAN = A + "product/can-uz.webp";
const BOLID = A + "f1/bolid.webp";
const PATTERN = A + "patterns/sting-pattern-red.svg";
const F1_LOGO = A + "f1/f1-logo.svg";
const STING_LOGO = A + "logo/sting-logo-white.svg";

/* Inline brand marks: any user-facing "Sting" word renders as the logo. */
const StingWord = () => (
  <img src={STING_LOGO} alt="Sting" style={{ height:"0.92em", verticalAlign:"-0.08em", display:"inline-block" }} />
);
export function withSting(text) {
  if (
    typeof text !== "string" ||
    text.toLowerCase().includes(BOT_USERNAME.toLowerCase()) ||
    !/sting/i.test(text)
  ) return text;
  const parts = text.split(/sting/i);
  return parts.flatMap((part, i) => (i === 0 ? [part] : [<StingWord key={i} />, part]));
}
export const F1Logo = ({ height = 14, style }) => (
  <img src={F1_LOGO} alt="Formula 1" style={Object.assign({ height, display:"block" }, style || {})} />
);
const approvedKv = (lang, shape="horizontal") => (
  A + `approved-kv/sting-promo-${shape}-${lang === "uz" ? "uz" : "ru"}.webp`
);

/* ---------- i18n (UZ overrides RU; missing keys fall back to RU) ----------
   The team x2 threshold is never spelled out as a literal in copy: it comes
   from `config/promo.config.json` through `promo.ts` (v9 mechanics package).
   `PLAYERS_RU/PLAYERS_UZ` are the agreement-safe "N участника" / "N ishtirokchi"
   renderings of that same threshold. */
const N_X2 = TEAM_BOOST_THRESHOLD;
const PLAYERS_RU = playersLabel(N_X2, "ru");
const PLAYERS_UZ = playersLabel(N_X2, "uz");
export const RU = {
  nav_home:"Главная", nav_team:"Команда", nav_baku:"Главный приз", nav_cab:"Кабинет", nav_scan:"Скан",
  hello:"Здравствуйте", points:"очки",
  attempts_label:"Попытки в мини-игре", attempts_help:"1 Sting в чеке = 1 попытка. Сыграть можно один раз в день.",
  attempts_saved:"Оставшиеся попытки сохранятся до следующей игры.",
  pit_open:"Мини игра открыта", pit_sub:"Играть можно в любое время до конца дня", play:"ИГРАТЬ",
  pit_next:"Мини игра", pit_done_sub:"Пройдено · завтра новая игра", pit_soon_sub:"Скоро открытие",
  tank:"Шансы ×2", tank_sub:`Если за день сыграют ${PLAYERS_RU} - шансы с их чеков этого дня ×2`, your_in:"ваши шансы",
  scan_tile:"Скан чека", scan_hint:"+шанс в розыгрыше", team_tile:"Команда", team_hint:"пригласить друзей",
  rules_tile:"Как участвовать", rules_hint:"краткая механика",
  scan_qr_only:"Сканируйте только QR-код на чеке", scan_qr_warn:"Другие чеки не принимаются",
  invite_benefit:`Пригласите друзей в команду. Если за день сыграют ${PLAYERS_RU}, шансы с чеков этого дня удвоятся у каждого, кто сыграл.`,
  tickets_tile:"Мои шансы", tickets_hint:"ваши шансы в розыгрыше", until_baku:"до розыгрыша поездки на двоих",
  team_title:"Команда", members:"участники", invite:"ПРИГЛАСИТЬ ДРУЗЕЙ", call_team:"ВЫЗВАТЬ КОМАНДУ", need_more:`Если ${PLAYERS_RU} команды сыграют в ежедневную мини-игру, шансы с чеков этого дня удвоятся у каждого, кто сыграл`,
  full:"Команда укомплектована", contribution:"шансы", captain:"капитан", leave:"Выйти из команды",
  baku_title:"Поездка на двоих", until_draw:"до розыгрыша", your_chance:"Каждый чек добавляет шанс",
  schedule:"Расписание", winners:"Победители", prize_name:"Поездка на двоих",
  cab_title:"Кабинет", scans:"сканы", pitstops:"мини игры", my_tickets:"Мои шансы",
  payout_status:"Призы", language:"Язык", rules:"Как участвовать", offer:"Правила акции", support:"Поддержка", logout:"Выйти",
  tk_title:"Мои шансы", in_game:"активно", tk_empty:"Сканируйте чек - каждый Sting в чеке даёт шанс в розыгрыше и 1 попытку в мини-игре",
  tk_none:"Сканируйте чек, чтобы получить первые шансы",
  scan_title:"Скан чека", scan_aim:"Наведите на QR-код чека", scan_manual:"Не работает камера? Вставьте сюда ссылку из чека",
  scan_auto:"Сканер откроется автоматически, если доступен",
  scan_camera:"Камера включена - наведите на QR-код чека",
  scan_telegram:"Открылся сканер Telegram",
  scan_btn:"ОТПРАВИТЬ ЧЕК", accepted:"Чек принят", limits:"До 5 Sting в чеке, до 3 чеков в день",
  pit_ready:"На старт…", pit_work:"Мини игра началась!", pit_gone:"Время вышло!",
  pit_hint:"Нажимайте зелёные точки как можно быстрее",
  results:"Мини игра закрыта", you:"Вы", oc:"оч.", again:"Скан чека", x2:"шансы ×2", dots:"точки",
  back:"Назад", continue:"Продолжить", level:"Гонщик",
  load_more:"Показать ещё",
  boost_on:"x2 включён", boost_to:"до x2", solo_mode:"играю один", member:"Участник", player:"Игрок",
  home_prizes:"Тур 1: 4 поездки на двоих",
  solo_can:"Можно играть и одному",
  solo_desc:`Можно играть и одному. Создайте команду и пригласите друзей: если за день мини-игру завершат ${PLAYERS_RU}, шансы с чеков этого дня удвоятся у каждого, кто сыграл.`,
  create_team:"Создать команду", played:"сыграл", waiting:"ждём",
  baku_eyebrow:"Призовой фонд Тура 1", baku_collect:"4 поездки на двоих",
  baku_manifest:"В поездку входят: 2 билета Grandstand; перелёт Ташкент - Баку - Ташкент; проживание в Holiday Inn Baku 4* с завтраком; трансфер аэропорт - отель - аэропорт в Баку.",
  baku_rules:"Открыть Правила акции",
  prize_main:"Приз Тура 1", prize_trip:"Поездка на двоих", baku_city:"Тур 1",
  fact_city:"приз", fact_seats:"поездок", fact_draw:"розыгрышей", fact_weekly:"4",
  fact_trip:"4 поездки", fact_tickets:"4 победителя", fact_days:"поездка на двоих",
  prize_desc:"Поездка на двоих. Полные условия приза указаны в Правилах акции.",
  baku_trip_dates:"Поездка: 23-27 сентября 2026",
  baku_more_tail:"Больше Sting в чеках - больше ваших шансов.",
  collapse:"Свернуть", why_baku:"Подробнее →", name_team:"Имя и команда", scan_receipt:"Сканировать чек",
  sec:"сек", penalties:"штрафы", you_got:"Вам:", points_gen:"очков",
  important:"важно", change_team:"Смена команды",
  team_keep:"Если вы выйдете или смените команду, текущие шансы останутся у вас.",
  team_name_ph:"Название команды", create_new_confirm:"Понимаю, создать новую", go_solo:"Играть одному", stay:"Остаться",
  profile:"Профиль", name_visible:"Имя видно в команде, результатах мини игры и сообщении-приглашении.",
  name_label:"Имя или ник", name_ph:"Например, Shima", team_name_label:"Название команды", save:"Сохранить", close:"Закрыть",
  invite_friends:"Пригласите друзей", check_bot:"Проверьте бота",
  invite_sent:`Сообщение с картинкой и ссылкой уже отправлено вам в Telegram-бот ${BOT_USERNAME}. Перешлите его тому, кого хотите пригласить в команду.`,
  invite_created:"Приглашение готово. Отправьте ссылку другу, чтобы он вступил в команду.",
  copy_link:"Скопировать ссылку", ok_got:"Понятно",
  share_story:"Поделиться в сториз", story_rally:"Позвать через сториз",
  story_result:"Похвастаться результатом", story_preview:"Ваша сториз",
  story_open_png:"Открыть PNG", story_copy_code:"Скопировать код", story_code_hint:"Если ссылка недоступна, отправьте этот код боту.",
  pit_jack:"Домкрат", pit_nut:"Гайка", pit_wheel:"Колесо", cans_short:"Sting",
  tick_zero:"1 Sting = 1 шанс в розыгрыше",
  tick_attempts:"1 Sting = 1 попытка в игре",
  tick_pit_open_tag:"Мини-игра", tick_pit_open:"Игра открыта - играйте",
  tick_pit_daily_tag:"Мини-игра", tick_pit_daily:"Каждый день · время в боте",
  tick_x2_tag:`Команда ${N_X2}+`, tick_x2:"Шансы с чеков ×2",
  tick_money_tag:"Тур 1", tick_money:"4 поездки на двоих",
  tick_chances:(n)=>`${n} ${n%10===1&&n%100!==11?"шанс":n%10>=2&&n%10<=4&&(n%100<10||n%100>=20)?"шанса":"шансов"} · розыгрыш`,
  tut_skip:"Пропустить", tut_step:"шаг", tut_next:"ДАЛЕЕ", tut_cta:"СКАНИРОВАТЬ ПЕРВЫЙ ЧЕК", tut_offer_cta:"ПЕРЕЙТИ К ПРАВИЛАМ",
  tut1_t:"КУПИТЕ STING", tut1_b:"1 Sting даёт шанс в розыгрыше поездки на двоих и 1 попытку в мини-игре.",
  tut_fiscal_t:"ПОПРОСИТЕ ЧЕК С QR-КОДОМ", tut_fiscal_b:"Обязательно попросите у продавца чек с QR-кодом. Другие чеки не принимаются.",
  tut2_t:"ОТСКАНИРУЙТЕ QR-КОД", tut2_b:"Наведите камеру на QR-код на чеке. 1 Sting = 1 шанс в розыгрыше и 1 попытка в мини-игре.",
  tut3_t:"ИГРАЙТЕ КАЖДЫЙ ДЕНЬ", tut3_b:"Раз в день бот пришлёт вам приглашение в мини-игру. Играть можно в любое время до конца дня.",
  tut_team_t:"ЗОВИТЕ ДРУЗЕЙ В КОМАНДУ", tut_team_b:`Если за день сыграют ${PLAYERS_RU} из команды - шансы с чеков этого дня удваиваются у каждого, кто сыграл.`,
  hint_team:`Пригласите друзей: ${PLAYERS_RU} в мини-игре за день - и шансы с чеков этого дня x2`,
  hint_baku:"Каждый Sting в чеке добавляет шанс на поездку на двоих",
  hint_tickets:"Здесь все ваши шансы текущего тура",
  hint_cab:"Шансы, призы и настройки - всё здесь",
  step1:"Купите", step2:"Сканируйте", step3:"Играйте",
  practice_t:"Мини-игра", practice_sub:"Тренировка: попробуйте механику, результат не сохранится",
  live_t:"Мини-игра идёт!",
  gi_title:"КАК ИГРАТЬ",
  gi_b1:"Каждый день в определённое время бот пришлёт приглашение - играть можно в любое время до конца дня.",
  gi_b2:"Нажимайте зелёные точки как можно быстрее - обслужите гоночную машину, как механики на трассе.",
  gi_b3:`Играйте командой: если за день мини-игру завершат ${PLAYERS_RU}, шансы с чеков этого дня удвоятся у каждого, кто сыграл. Соревнуйтесь, кто быстрее.`,
  gi_cta:"ТРЕНИРОВАТЬСЯ",
  howto:"Как это работает", sound:"Звук", sound_on:"Вкл", sound_off:"Выкл",
  fact_km:"км", fact_laps:"кругов", fact_turns:"поворотов", fact_record:"рекорд", your_prize:"ВАШ ПРИЗ",
  ann_title:"МИНИ-ИГРА СЕГОДНЯ",
  ann_start:(t)=>`Старт в ${t}`,
  ann_countdown:"До старта",
  live_left:(m)=>`До конца ${m} мин`,
  closed_today:"Мини-игра на сегодня завершена - завтра новая",
  no_window_hint:"Время мини-игры объявим в боте",
  your_result:"Ваш результат",
  lb_title:"Сегодняшняя мини-игра",
  lb_time:"время", lb_pts:"очки",
  call_done:"Команда уже позвана",
  x2_note:`Когда за день сыграют ${PLAYERS_RU}, шансы с чеков этого дня ×2 получат все, кто сыграл - даже те, кто финишировал раньше.`,
  x2_how:"Как работает удвоение",
  ref_join:`Друг вошёл по вашей ссылке: +${attemptsLabel(REFERRAL.joinAttemptBonus, "ru")} в мини-игре вам и ему.`,
  ref_receipt:`Его первый чек: +${chancesLabel(REFERRAL.firstReceiptTicketBonus, "ru")} в розыгрыше вам и ему.`,
  ride_counted:"МИНИ-ИГРА ЗАСЧИТАНА", game_no_chance:"Мини-игра сама не добавляет шанс. Она помогает команде активировать x2 для сегодняшних шансов.",
  invite_friends_cta:"ПРИГЛАСИТЬ ДРУЗЕЙ", play_now:"ИГРАТЬ", scan_receipt_cta:"СКАНИРОВАТЬ ЧЕК",
  ready_title:"ГОТОВЫ К МИНИ-ИГРЕ?", ready_spend:"После старта спишется одна попытка.",
  no_attempts_title:"НЕТ ПОПЫТОК ДЛЯ ИГРЫ", no_attempts_body:"Купите Sting, попросите на кассе чек с QR-кодом и отсканируйте его, чтобы получить попытку.",
  time_left:"До закрытия окна",
};
const UZ = {
  nav_home:"Asosiy", nav_team:"Jamoa", nav_baku:"Bosh sovrin", nav_cab:"Kabinet", nav_scan:"Skan",
  hello:"Assalomu alaykum", points:"ball",
  attempts_label:"Mini-oʼyin urinishlari", attempts_help:"Chekdagi 1 ta Sting = 1 ta urinish. Kuniga bir marta oʼynash mumkin.",
  attempts_saved:"Qolgan urinishlar keyingi oʼyingacha saqlanadi.",
  pit_open:"Mini o'yin ochiq", pit_sub:"Kun oxirigacha istalgan vaqtda oʼynashingiz mumkin", play:"O'YNASH",
  pit_next:"Mini o'yin", pit_done_sub:"Oʼtildi · ertaga yangi oʼyin", pit_soon_sub:"Tez orada ochiladi",
  tank:"Imkoniyatlar ×2", tank_sub:`Bir kunda ${PLAYERS_UZ} oʼynasa - oʼynaganlarning oʼsha kungi imkoniyatlari ×2`, your_in:"imkoniyatlaringiz",
  scan_tile:"Chekni skanlash", scan_hint:"+qurʼada imkoniyat", team_tile:"Jamoa", tickets_tile:"Imkoniyatlarim", until_baku:"ikki kishilik sayohat qurʼasigacha",
  rules_tile:"Qanday ishtirok etish", rules_hint:"qisqa mexanika",
  scan_qr_only:"Faqat chekdagi QR-kodni skanlang", scan_qr_warn:"Boshqa cheklar qabul qilinmaydi",
  invite_benefit:`Doʼstlaringizni jamoaga taklif qiling. Bir kunda ${PLAYERS_UZ} oʼynasa, oʼsha kungi cheklar imkoniyatlari oʼynagan har bir kishida ikki barobar boʼladi.`,
  team_title:"Jamoa", invite:"DOʻSTLARNI TAKLIF QILING", baku_title:"Ikki kishilik sayohat",
  cab_title:"Kabinet", pitstops:"mini o'yinlar", my_tickets:"Imkoniyatlarim", language:"Til", rules:"Qanday ishtirok etish", offer:"Aksiya qoidalari",
  support:"Yordam", logout:"Chiqish", tk_title:"Imkoniyatlarim", in_game:"faol",
  scan_title:"Chekni skanlash", scan_btn:"CHEKNI YUBORISH", accepted:"Chek qabul qilindi",
  scan_aim:"Chek QR-kodini yoʻnaltiring", scan_manual:"Kamera ishlamayaptimi? Chekdagi havolani shu yerga joylang",
  scan_auto:"Skaner mavjud bo'lsa, avtomatik ochiladi",
  scan_camera:"Kamera yoqildi - chek QR-kodiga yoʻnaltiring",
  scan_telegram:"Telegram skaneri ochildi",
  pit_work:"Mini o'yin boshlandi!", results:"Mini o'yin yopildi", you:"Siz", again:"Chekni skanlash",
  payout_status:"Sovrinlar", back:"Orqaga", continue:"Davom etish",
  load_more:"Yana koʼrsatish",
  team_hint:"doʻstlarni taklif qilish", tickets_hint:"qurʼadagi imkoniyatlaringiz", members:"ishtirokchilar",
  call_team:"JAMOANI CHAQIRISH", need_more:`Jamoadan ${PLAYERS_UZ} kunlik mini-oʼyinda oʼynasa, oʼsha kungi cheklar imkoniyatlari oʼynagan har bir kishida ikki barobar boʼladi`,
  full:"Jamoa toʻldi", contribution:"imkoniyatlar", captain:"kapitan", leave:"Jamoadan chiqish",
  until_draw:"qurʼagacha", your_chance:"Har bir chek imkoniyat qoʻshadi",
  schedule:"Jadval", winners:"Gʼoliblar", prize_name:"Ikki kishilik sayohat",
  scans:"skanlar", tk_empty:"Chekni skanlang - chekdagi har bir Sting qurʼada imkoniyat va mini-oʼyinda 1 urinish beradi",
  tk_none:"Birinchi imkoniyatlarni olish uchun chekni skanlang",
  limits:"Chekda 5 tagacha Sting, kuniga 3 tagacha chek",
  pit_ready:"Startga tayyorlaning…", pit_gone:"Vaqt tugadi!", pit_hint:"Yashil nuqtalarni imkon qadar tez bosing",
  oc:"ball", x2:"imkoniyatlar ×2", dots:"nuqtalar", level:"Poygachi",
  boost_on:"x2 yoqildi", boost_to:"x2gacha", solo_mode:"yakka oʼynayman", member:"Ishtirokchi", player:"Oʻyinchi",
  home_prizes:"1-tur: 4 ta ikki kishilik sayohat",
  solo_can:"Yakka ham oʼynash mumkin",
  solo_desc:`Yakka ham oʼynash mumkin. Jamoa tuzing va doʼstlaringizni taklif qiling: bir kunda ${PLAYERS_UZ} mini-oʼyinni yakunlasa, oʼsha kungi cheklar imkoniyatlari oʼynagan har bir kishida ikki barobar boʼladi.`,
  create_team:"Jamoa tuzish", played:"oʻynadi", waiting:"kutyapmiz",
  baku_eyebrow:"1-tur sovrin jamgʼarmasi", baku_collect:"4 ta ikki kishilik sayohat",
  baku_manifest:"Sayohatga quyidagilar kiradi: 2 ta Grandstand chiptasi; Toshkent - Boku - Toshkent yoʼnalishi boʼyicha aviaparvoz; Holiday Inn Baku 4* mehmonxonasida nonushta bilan yashash; Bokuda aeroport - mehmonxona - aeroport yoʼnalishi boʼyicha transfer.",
  baku_rules:"Aksiya qoidalarini ochish",
  prize_main:"1-tur sovrini", prize_trip:"Ikki kishilik sayohat", baku_city:"1-tur",
  fact_city:"sovrin", fact_seats:"sayohat", fact_draw:"qurʼa", fact_weekly:"4",
  fact_trip:"4 ta sayohat", fact_tickets:"4 nafar gʼolib", fact_days:"ikki kishilik",
  prize_desc:"Ikki kishilik sayohat. Sovrinning toʼliq shartlari Aksiya qoidalarida koʼrsatilgan.",
  baku_trip_dates:"Sayohat: 2026-yil 23-27-sentabr",
  baku_more_tail:"Cheklarda Sting koʼp boʼlsa - imkoniyat ham koʼp boʼladi.",
  collapse:"Yigʻish", why_baku:"Batafsil →", name_team:"Ism va jamoa", scan_receipt:"Chekni skanlash",
  sec:"soniya", penalties:"jarimalar", you_got:"Sizga:", points_gen:"ball",
  important:"muhim", change_team:"Jamoani almashtirish",
  team_keep:"Jamoadan chiqsangiz yoki uni almashtirsangiz, joriy imkoniyatlaringiz sizda qoladi.",
  team_name_ph:"Jamoa nomi", create_new_confirm:"Tushunaman, yangisini tuzaman", go_solo:"Yakka oʼynash", stay:"Qolish",
  profile:"Profil", name_visible:"Ism jamoada, mini-oʻyin natijalarida va taklif xabarida koʻrinadi.",
  name_label:"Ism yoki taxallus", name_ph:"Masalan, Shima", team_name_label:"Jamoa nomi", save:"Saqlash", close:"Yopish",
  invite_friends:"Doʻstlaringizni taklif qiling", check_bot:"Botni tekshiring",
  invite_sent:`Rasm va havola bilan xabar sizga ${BOT_USERNAME} Telegram-botiga allaqachon yuborildi. Uni jamoaga taklif qilmoqchi boʻlgan kishiga uzating.`,
  invite_created:"Taklif tayyor. Doʼstingiz jamoaga qoʼshilishi uchun havolani yuboring.",
  copy_link:"Havoladan nusxa olish", ok_got:"Tushunarli",
  share_story:"Storiesda ulashish", story_rally:"Stories orqali chaqirish",
  story_result:"Natijani ulashish", story_preview:"Stories kartangiz",
  story_open_png:"PNGni ochish", story_copy_code:"Koddan nusxa olish", story_code_hint:"Havola ochilmasa, ushbu kodni botga yuboring.",
  pit_jack:"Domkrat", pit_nut:"Gayka", pit_wheel:"Gʻildirak", cans_short:"Sting",
  tick_zero:"1 ta Sting = qurʼada 1 imkoniyat",
  tick_attempts:"1 ta Sting = oʼyinda 1 urinish",
  tick_pit_open_tag:"Mini-oʼyin", tick_pit_open:"Oʼyin ochiq - oʼynang",
  tick_pit_daily_tag:"Mini-oʼyin", tick_pit_daily:"Har kuni · vaqti botda",
  tick_x2_tag:`Jamoa ${N_X2}+`, tick_x2:"Cheklar imkoniyatlari ×2",
  tick_money_tag:"1-tur", tick_money:"4 ta ikki kishilik sayohat",
  tick_chances:(n)=>`${n} imkoniyat · qurʼa`,
  tut_skip:"Oʼtkazib yuborish", tut_step:"qadam", tut_next:"KEYINGISI", tut_cta:"BIRINCHI CHEKNI SKANLANG", tut_offer_cta:"QOIDALARGA OʼTISH",
  tut1_t:"STING SOTIB OLING", tut1_b:"1 ta Sting ikki kishilik sayohat qurʼasida imkoniyat va mini-oʼyinda 1 ta urinish beradi.",
  tut_fiscal_t:"QR-KODLI CHEK SOʼRANG", tut_fiscal_b:"Sotuvchidan albatta QR-kodli chek soʼrang. Boshqa cheklar qabul qilinmaydi.",
  tut2_t:"QR-KODNI SKANLANG", tut2_b:"Kamerani chekdagi QR-kodga yoʼnaltiring. 1 ta Sting = qurʼada 1 imkoniyat va mini-oʼyinda 1 ta urinish.",
  tut3_t:"HAR KUNI OʼYNANG", tut3_b:"Kuniga bir marta bot Sizga mini-oʼyinga taklif yuboradi. Kun oxirigacha istalgan vaqtda oʼynashingiz mumkin.",
  tut_team_t:"DOʼSTLARNI JAMOAGA CHAQIRING", tut_team_b:`Bir kunda jamoadan ${PLAYERS_UZ} oʼynasa - oʼsha kungi cheklar imkoniyatlari oʼynagan har bir kishida ikki barobar boʼladi.`,
  hint_team:`Doʼstlaringizni taklif qiling: bir kunda mini-oʼyinda ${PLAYERS_UZ} boʼlsa - oʼsha kungi cheklar imkoniyatlari x2`,
  hint_baku:"Chekdagi har bir Sting ikki kishilik sayohat uchun imkoniyat qoʼshadi",
  hint_tickets:"Bu yerda joriy turdagi barcha imkoniyatlaringiz",
  hint_cab:"Imkoniyatlar, sovrinlar va sozlamalar - hammasi shu yerda",
  step1:"Oling", step2:"Skanlang", step3:"Oʼynang",
  practice_t:"Mini-oʼyin", practice_sub:"Mashq: mexanikani sinab koʼring, natija saqlanmaydi",
  live_t:"Mini-oʼyin ketyapti!",
  gi_title:"QANDAY OʼYNALADI",
  gi_b1:"Har kuni maʼlum vaqtda bot taklif yuboradi - kun oxirigacha istalgan vaqtda oʼynashingiz mumkin.",
  gi_b2:"Yashil nuqtalarni imkon qadar tez bosing - haqiqiy trekdagi mexaniklar kabi bolidga xizmat koʼrsating.",
  gi_b3:`Jamoa boʼlib oʼynang: bir kunda ${PLAYERS_UZ} mini-oʼyinni yakunlasa, oʼsha kungi cheklar imkoniyatlari oʼynagan har bir kishida ikki barobar boʼladi. Kim tezroq - bellashing.`,
  gi_cta:"MASHQ QILISH",
  howto:"Bu qanday ishlaydi", sound:"Ovoz", sound_on:"Yoniq", sound_off:"Oʼchiq",
  fact_km:"km", fact_laps:"aylana", fact_turns:"burilish", fact_record:"rekord", your_prize:"SOVRININGIZ",
  ann_title:"BUGUN MINI-OʼYIN",
  ann_start:(t)=>`Start soat ${t} da`,
  ann_countdown:"Startgacha",
  live_left:(m)=>`Tugashiga ${m} daqiqa`,
  closed_today:"Bugungi mini-oʼyin tugadi - ertaga yangisi",
  no_window_hint:"Mini-oʼyin vaqtini botda eʼlon qilamiz",
  your_result:"Natijangiz",
  lb_title:"Bugungi mini-oʼyin",
  lb_time:"vaqt", lb_pts:"ball",
  call_done:"Jamoa allaqachon chaqirildi",
  x2_note:`Bir kunda ${PLAYERS_UZ} oʼynasa, oʼsha kungi cheklar imkoniyatlari ×2 ni oʼynaganlarning hammasi oladi - avvalroq marraga yetganlar ham.`,
  x2_how:"Ikki barobar qanday ishlaydi",
  ref_join:`Doʼstingiz havolangiz orqali kirdi: mini-oʼyinda Sizga ham, unga ham +${attemptsLabel(REFERRAL.joinAttemptBonus, "uz")}.`,
  ref_receipt:`Uning birinchi chegi: qurʼada Sizga ham, unga ham +${chancesLabel(REFERRAL.firstReceiptTicketBonus, "uz")}.`,
  ride_counted:"MINI-OʼYIN HISOBGA OLINDI", game_no_chance:"Mini-oʼyin oʼzi imkoniyat qoʼshmaydi. U jamoaga bugungi imkoniyatlar uchun x2 ni faollashtirishga yordam beradi.",
  invite_friends_cta:"DOʼSTLARNI TAKLIF QILISH", play_now:"OʼYNASH", scan_receipt_cta:"CHEKNI SKANERLASH",
  ready_title:"MINI-OʼYINGA TAYYORMISIZ?", ready_spend:"Startdan keyin bitta urinish ishlatiladi.",
  no_attempts_title:"OʼYIN UCHUN URINISH YOʼQ", no_attempts_body:"Sting xarid qiling, kassadan QR-kodli chek soʼrang va urinish olish uchun uni skanerlang.",
  time_left:"Oyna yopilishiga",
};
export const L = (lang) => (lang === "uz" ? Object.assign({}, RU, UZ) : RU);
function chanceWord(count, lang) {
  if (lang === "uz") return "imkoniyat";
  const mod10 = count % 10;
  const mod100 = count % 100;
  if (mod10 === 1 && mod100 !== 11) return "шанс";
  if (mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14)) return "шанса";
  return "шансов";
}

/* ---------- shared bits ---------- */
function inject(){
  if (document.getElementById("sting-app-css")) return;
  const s = document.createElement("style"); s.id = "sting-app-css";
  s.textContent = `
  .posnode{cursor:pointer}
  .posnode .hit{fill:transparent}
  .posnode .c{fill:var(--ink-700);stroke:#3a0b0e;stroke-width:1.5;transition:.15s}
  .posnode text{fill:var(--text-muted);font-family:var(--font-body);font-weight:700;font-size:11px;text-anchor:middle;pointer-events:none}
  .posnode.active .c{fill:var(--success);stroke:#9dffc4;animation:pn 0.7s ease infinite}
  .posnode.active text{fill:#fff}
  .posnode.done .c{fill:#fff;stroke:#fff;animation:none}
  .posnode.miss .c{fill:#7a0009;stroke:var(--brand);animation:none}
  @keyframes pn{50%{stroke-width:6}}
  .lite{width:17px;height:17px;border-radius:50%;background:#2a0608;border:1px solid #3a0b0e;transition:.1s}
  .lite.on{background:radial-gradient(circle at 40% 35%,#ff6a6a,var(--brand) 60%,#7a0009);box-shadow:0 0 12px 3px var(--brand-glow)}
  .pclock.pen{animation:pf .35s ease}
  @keyframes pf{30%{color:var(--brand)}}
  @keyframes fadeIn{from{opacity:0;transform:translateY(4px)}to{opacity:1;transform:translateY(0)}}
  .ovl-in{animation:ovlIn .22s ease both}
  .ovl-in>*{animation:cardIn .26s cubic-bezier(0.22,1,0.36,1) both}
  .story-dialog{position:absolute;inset:0;z-index:80;width:100%;height:100%;max-width:none;max-height:none;margin:0;border:0;padding:18px;background:var(--surface-overlay);color:inherit;align-items:center;justify-content:center;box-sizing:border-box}
  .story-dialog[open]{display:flex}
  .story-dialog::backdrop{background:transparent}
  .story-dialog-card{width:100%;max-width:390px;max-height:94%;overflow-y:auto;background:var(--surface-card);border:1px solid var(--border-subtle);border-radius:var(--r-xl);padding:18px;box-sizing:border-box}
  .story-preview-image{display:block;width:min(100%,250px);aspect-ratio:9/16;object-fit:cover;margin:14px auto;border-radius:var(--r-md);background:var(--ink-800)}
  .story-code-row{display:flex;align-items:center;justify-content:space-between;gap:12px;padding:10px 12px;border-radius:var(--r-md);background:var(--ink-800);margin-bottom:8px}
  .story-code-copy{border:0;background:transparent;color:var(--text-strong);font-family:var(--font-body);font-weight:700;cursor:pointer}
  .story-close{width:100%;height:42px;margin-top:8px;border:0;background:transparent;color:var(--text-muted);font-family:var(--font-body);cursor:pointer}
  .sheet-in{animation:ovlIn .22s ease both}
  .sheet-in>*{animation:sheetIn .3s cubic-bezier(0.32,0.72,0,1) both}
  @keyframes ovlIn{from{opacity:0}}
  @keyframes cardIn{from{opacity:0;transform:translateY(12px) scale(.95)}}
  @keyframes sheetIn{from{opacity:0;transform:translateY(46px)}}
  #pfin{animation:ovlIn .3s ease both}
  @media(prefers-reduced-motion:reduce){.ovl-in>*,.sheet-in>*{animation:ovlIn .15s ease both}}
  .tilepress{transition:transform .12s cubic-bezier(0.22,1,0.36,1)}
  .tilepress:active{transform:scale(.97)}
  .ctapulse{animation:ctapulse 1.5s ease-out infinite}
  @keyframes ctapulse{0%{box-shadow:0 0 0 0 rgba(214,35,0,.55)}70%{box-shadow:0 0 0 14px rgba(214,35,0,0)}100%{box-shadow:0 0 0 0 rgba(214,35,0,0)}}
  @media(prefers-reduced-motion:reduce){.ctapulse{animation:none}}
  `;
  document.head.appendChild(s);
}

function Eyebrow({ children, color }) {
  return <div style={{ fontFamily:"var(--font-body)", fontSize:11, fontWeight:700, textTransform:"uppercase", letterSpacing:"0.12em", color: color || "var(--text-muted)" }}>{children}</div>;
}
function H1({ children, size }) {
  return <h1 style={{ fontFamily:"var(--font-display)", fontWeight:900, fontSize:size||30, textTransform:"uppercase", letterSpacing:"-0.01em", lineHeight:.95, color:"var(--text-strong)", margin:0 }}>{children}</h1>;
}
function BigButton({ actionId, children, onClick, tone, icon, disabled }) {
  const gold = tone === "gold";
  return (
    <button data-ui-action={actionId} aria-disabled={disabled ? "true" : "false"} onPointerDown={disabled ? undefined : (e)=>J.cta(e.currentTarget)} onClick={(event)=>{ if (disabled) { event.preventDefault(); return; } onClick?.(event); }} className="tilepress" style={{
      width:"100%", border:"none", cursor:disabled?"not-allowed":"pointer", height:58, borderRadius:"var(--r-lg)",
      background: gold ? "var(--grad-gold)" : "var(--grad-red)",
      color: gold ? "#000" : "#fff", boxShadow:"var(--shadow-brand)",
      fontFamily:"var(--font-heading)", fontSize:16, textTransform:"uppercase", letterSpacing:"0.02em",
      display:"flex", alignItems:"center", justifyContent:"center", gap:10, transition:"transform .12s", opacity:disabled ? .72 : 1,
    }}>
      {icon && <Icon name={icon} size={20} color={gold ? "#000" : "#fff"} fill={icon==="bolt"?(gold?"#000":"#fff"):"none"} />}
      {children}
    </button>
  );
}
function VisualCrop({ src, height=150, position="top", radius="var(--r-lg)", style }) {
  return (
    <img
      src={src}
      alt=""
      loading="lazy"
      aria-hidden="true"
      style={Object.assign({
        width:"100%",
        height,
        objectFit:"cover",
        objectPosition:position,
        borderRadius:radius,
        display:"block",
        border:"1px solid var(--border-subtle)",
        background:"var(--ink-900)",
      }, style || {})}
    />
  );
}

/* one-line instruction: what to do here + what you get */
function HintLine({ text, style }) {
  return (
    <div style={Object.assign({ display:"flex", alignItems:"center", gap:8, marginTop:12, padding:"9px 12px", borderRadius:"var(--r-lg)", background:"var(--surface-card)", border:"1px solid var(--border-subtle)" }, style || {})}>
      <Icon name="bolt" size={14} color="var(--sting-gold)" fill="var(--sting-gold)" />
      <span style={{ fontFamily:"var(--font-body)", fontSize:12, color:"var(--text-muted)", lineHeight:1.35 }}>{withSting(text)}</span>
    </div>
  );
}

/* big number hero */
function StatHero({ value, label }) {
  return (
    <div style={{ display:"flex", alignItems:"flex-end", gap:10 }}>
      <Icon name="bolt" size={34} color="var(--sting-gold)" fill="var(--sting-gold)" />
      <div style={{ fontFamily:"var(--font-display)", fontWeight:900, fontSize:64, lineHeight:.82, color:"#fff" }}>{value}</div>
      <div style={{ fontFamily:"var(--font-heading)", fontSize:13, textTransform:"uppercase", letterSpacing:"0.1em", color:"rgba(255,255,255,.75)", paddingBottom:8 }}>{label}</div>
    </div>
  );
}
function TimerPill({ children }) {
  return (
    <div style={{ display:"inline-flex", alignItems:"center", gap:7, background:"rgba(0,0,0,.4)", borderRadius:"var(--r-pill)", padding:"7px 13px" }}>
      <Icon name="clock" size={15} color="var(--text-muted)" />
      <span style={{ fontFamily:"var(--font-heading)", fontSize:13, color:"#fff" }}>{children}</span>
    </div>
  );
}
function Tile({ actionId, icon, title, hint, onClick, done }) {
  return (
    <button data-ui-action={actionId} onClick={onClick} className="tilepress" style={{
      flex:1, border:"1px solid var(--border-subtle)", background:"var(--surface-card)", cursor:"pointer",
      borderRadius:"var(--r-xl)", padding:"16px 14px", textAlign:"left", display:"flex", flexDirection:"column", gap:10, transition:"transform .12s",
    }}>
      <div style={{ width:44, height:44, borderRadius:"var(--r-md)", background: done ? "rgba(24,178,107,.15)" : "rgba(214,35,0,.14)", display:"flex", alignItems:"center", justifyContent:"center" }}>
        <Icon name={done ? "check" : icon} size={24} color={done ? "var(--success)" : "var(--brand)"} />
      </div>
      <div>
        <div style={{ fontFamily:"var(--font-heading)", fontSize:15, color:"var(--text-strong)", textTransform:"uppercase" }}>{title}</div>
        <div style={{ fontFamily:"var(--font-body)", fontSize:12, color:"var(--text-muted)", marginTop:2 }}>{hint}</div>
      </div>
    </button>
  );
}

/* looping muted video backdrop (autoplay) */
function VideoBg({ src, poster, style }) {
  const ref = React.useRef(null);
  React.useEffect(()=>{ const v=ref.current; if(!v) return; v.muted=true; const p=v.play(); if(p&&p.catch) p.catch(()=>{}); },[]);
  return (
    <video ref={ref} autoPlay muted loop playsInline poster={poster}
      style={Object.assign({ position:"absolute", pointerEvents:"none", objectFit:"cover" }, style)}>
      <source src={src} type="video/webm" />
    </video>
  );
}

/* Electric can - the single eligible 0.449 L product with procedural SVG
   discharges hugging its silhouette. No WebGL in the WebView (compositor risks - see
   docs/reports/landing-lightning-postmortem-2026-07-03.md) and no rAF: cheap
   Android + slow network audience. Rotation lives on wrapper spans so the zap
   animation's transform:scale never fights the tilt. */
function ElectricCan({ height=340, active=true, style }) {
  const uid = React.useId().replace(/[:]/g,"");
  const red = "var(--sting-red)", dred = "var(--dark-red)";
  const kP = "ebp"+uid, kA1 = "eba1"+uid, kA2 = "eba2"+uid, kA3 = "eba3"+uid, cI = "ebi"+uid, cA = "eba"+uid;
  const baseF = "drop-shadow(0 0 1px #fff) drop-shadow(0 0 3px "+red+") drop-shadow(0 0 6px "+red+")";
  const css =
    "@keyframes "+kP+"{0%,100%{filter:"+baseF+"}50%{filter:drop-shadow(0 0 2px #fff) drop-shadow(0 0 6px "+red+") drop-shadow(0 0 13px "+dred+")}}"
    +"@keyframes "+kA1+"{0%{stroke-dashoffset:320;opacity:0}12%{opacity:1}60%{opacity:1}100%{stroke-dashoffset:0;opacity:0}}"
    +"@keyframes "+kA2+"{0%{stroke-dashoffset:0;opacity:0}15%{opacity:1}65%{opacity:1}100%{stroke-dashoffset:320;opacity:0}}"
    +"@keyframes "+kA3+"{0%{stroke-dashoffset:300;opacity:0}20%{opacity:1}70%{opacity:.9}100%{stroke-dashoffset:-20;opacity:0}}"
    +"."+cI+"{animation:"+kP+" 2.4s var(--ease-out) infinite}"
    +"."+cA+"{fill:none;stroke:#fff;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;filter:drop-shadow(0 0 3px "+red+") drop-shadow(0 0 6px "+red+");stroke-dasharray:60 260}"
    +"@keyframes ebz"+uid+"{0%{filter:drop-shadow(0 0 4px #fff) drop-shadow(0 0 12px "+red+") drop-shadow(0 0 22px "+red+");transform:scale(1.03)}100%{filter:"+baseF+";transform:scale(1)}}"
    +"."+cI+".zap{animation:ebz"+uid+" .3s ease-out both}"
    +"@media(prefers-reduced-motion:reduce){."+cI+"{animation:none}."+cA+"{animation:none;opacity:.85}."+cI+".zap{animation:none}}";
  // easter egg: tapping the products discharges them - flash + crackle, no meaning, pure aliveness
  const zap = (e)=>{
    e.currentTarget.querySelectorAll("img").forEach((img)=>{ img.classList.remove("zap"); void img.offsetWidth; img.classList.add("zap"); });
    Snd.playTool("crackle");
    Hx.impact("light");
  };
  return (
    <div data-ui-action="product:can_zap" onPointerDown={zap} style={Object.assign({ position:"relative", height:height, aspectRatio:"160 / 340" }, style)}>
      <style>{css}</style>
      <div style={{ position:"absolute", inset:0, display:"flex", alignItems:"flex-end", justifyContent:"center" }}>
        <span style={{ position:"relative", zIndex:2, height:"92%", transform:"rotate(-4deg)", transformOrigin:"50% 88%" }}>
          <img className={cI} src={PRODUCT_CAN} alt="STING" style={{ height:"100%", display:"block", filter:baseF }} />
        </span>
      </div>
      {active && (
        <svg viewBox="0 0 185 340" preserveAspectRatio="none" style={{ position:"absolute", inset:0, zIndex:3, width:"100%", height:"100%", overflow:"visible", pointerEvents:"none" }} aria-hidden="true">
          <path className={cA} style={{ animation:kA1+" 2.1s linear infinite" }} d="M30 124 L20 150 L32 158 L18 188 L30 204 L16 242 L28 260 L14 300 L26 320 L18 335" />
          <path className={cA} style={{ animation:kA2+" 1.7s linear infinite .4s" }} d="M172 78 L182 104 L170 116 L184 144 L172 166 L182 204 L170 226 L182 262 L172 286" />
          <path className={cA} style={{ animation:kA3+" 2.6s linear infinite .9s" }} d="M104 40 L94 56 L108 64 L98 82 L112 94" />
        </svg>
      )}
    </div>
  );
}

/* ---------- bottom nav: Главная · [СКАН] · Кабинет (client edit #3) ---------- */
function BottomNav({ active, onNav, lang }) {
  const l = L(lang);
  const left = [ {id:"home",icon:"home",label:l.nav_home} ];
  const right = [ {id:"cabinet",icon:"user",label:l.nav_cab} ];
  const item = (it) => {
    const on = active === it.id;
    return (
      <button key={it.id} data-ui-action={`bottom_nav:${it.id}`} aria-label={it.label} onPointerDown={(e)=>J.tab(e.currentTarget)} onClick={()=>onNav(it.id)} style={{ border:"none", background:"transparent", cursor:"pointer", display:"flex", flexDirection:"column", alignItems:"center", gap:4, width:58 }}>
        <Icon name={it.icon} size={23} color={on ? "var(--brand)" : "var(--text-muted)"} />
      </button>
    );
  };
  return (
    <div data-ui-role="bottom-nav" style={{ flex:"none", position:"relative", zIndex:30, overflow:"visible", display:"flex", alignItems:"flex-end", justifyContent:"space-around", padding:"10px 12px 24px", background:"var(--ink-800)", borderTop:"1px solid var(--border-subtle)" }}>
      {left.map(item)}
      <button data-ui-action="bottom_nav:scan" aria-label={l.nav_scan} onPointerDown={(e)=>J.tab(e.currentTarget)} onClick={()=>onNav("scan")} className="tilepress" style={{ position:"relative", zIndex:1, border:"none", cursor:"pointer", width:64, height:64, marginTop:-28, borderRadius:"50%", background:"var(--grad-red)", boxShadow:"var(--shadow-brand)", display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", gap:1, transition:"transform .12s" }}>
        <Icon name="scan" size={24} color="#fff" />
        <span style={{ fontFamily:"var(--font-heading)", fontSize:8, color:"#fff", textTransform:"uppercase", letterSpacing:"0.05em" }}>{L(lang).nav_scan}</span>
      </button>
      {right.map(item)}
    </div>
  );
}

/* ---------- LOGIN ---------- */
function LoginScreen({ onLogin, lang }) {
  const l = L(lang);
  return (
    <div style={{ flex:1, display:"flex", flexDirection:"column", position:"relative", backgroundImage:`url(${PATTERN})`, backgroundSize:"cover", backgroundPosition:"center", overflow:"hidden" }}>
      <div style={{ position:"absolute", inset:0, background:"var(--grad-scrim)" }} />
      {/* animated single eligible can */}
      <div style={{ position:"relative", flex:1, display:"flex", alignItems:"center", justifyContent:"center", padding:"20px 0 0" }}>
        <ElectricCan height={340} />
      </div>
      {/* brand + cta */}
      <div style={{ position:"relative", padding:"0 24px 34px", textAlign:"center" }}>
        <img src={A+"logo/sting-logo-black.svg"} alt="STING" style={{ height:44, marginBottom:8, filter:"drop-shadow(0 6px 16px rgba(0,0,0,.45))" }} />
        <H1 size={42}>{lang==="uz"?"POYGASI":"ГОНКА"}</H1>
        <p style={{ fontFamily:"var(--font-body)", fontSize:14, color:"var(--text-body)", lineHeight:1.45, margin:"12px auto 20px", maxWidth:300 }}>
          {lang==="uz"
            ? "Sting sotib oling, chekni skanerlang va ikki kishilik sayohat qurʼasida imkoniyatlar toʼplang."
            : "Покупайте Sting, сканируйте чеки и копите шансы в розыгрыше поездки на двоих."}
        </p>
        <BigButton actionId="auth:login" onClick={onLogin} icon="chevron">{lang==="uz"?"KIRISH":"ВОЙТИ"}</BigButton>
      </div>
    </div>
  );
}

/* ---------- HOME ---------- */
function HomeScreen({ user, team, points, tickets, pitStop, showPoints = true, onNav, onBakuFocus, onPlay, onPractice, onCall, onStoryRally, storySharing, lang, disabled }) {
  const l = L(lang);
  const displayName = user?.name || (lang === "uz" ? "Ishtirokchi" : "Участник");
  const ps = pitStop || {};
  const win = ps.window || null;
  const nowMs = useNowTicker(!!win, ps.serverNow);
  const phase = phaseOf(win, nowMs); // none | announced | live | closed
  const played = !!ps.playedSelf;
  const canPlay = !!ps.canPlay;
  const results = ps.results || [];
  const ownRow = results.find((r) => r.userId === user?.id);
  const callAllowed =
    !!team && !!win && !ps.callUsed && phase !== "closed" && (team.playedCount || 0) < teamBoostThreshold(team);
  const boostText = team
    ? (team.boostActive
        ? l.boost_on
        : (lang === "uz"
            ? `x2gacha yana ${playersLabel(team.missingForBoost || 0, "uz")}`
            : `ещё ${playersLabel(team.missingForBoost || 0, "ru")} до x2`))
    : l.solo_mode;
  const tickerItems = [
    ...(canPlay ? [{ actionId:"play", icon:"flag", gold:true, tag:l.tick_pit_open_tag, title:l.tick_pit_open, target:"play" }] : []),
    ...(phase === "announced"
      ? [{ actionId:"window", icon:"clock", gold:true, tag:l.tick_pit_daily_tag, title:l.ann_start(fmtHhMmTashkent(win.startsAt)), target:"home" }]
      : []),
    ...(tickets > 0 ? [{ actionId:"tickets", icon:"ticket", tag:l.tickets_tile, title:l.tick_chances(tickets), target:"tickets" }] : []),
    { actionId:"scan", icon:"scan", tag:l.baku_city, title:l.tick_zero, target:"scan" },
    { actionId:"attempts", icon:"bolt", tag:l.pit_next, title:l.tick_attempts, target:"scan" },
    ...(canPlay || phase === "announced" ? [] : [{ actionId:"window", icon:"clock", tag:l.tick_pit_daily_tag, title:l.tick_pit_daily, target:"home" }]),
    { actionId:"team", icon:"users", tag:l.tick_x2_tag, title:l.tick_x2, target:"team" },
    { actionId:"prizes", icon:"gift", tag:l.tick_money_tag, title:l.tick_money, target:"cabinet" },
  ];
  return (
    <div style={{ flex:1, overflowY:"auto", background:"var(--surface-base)" }}>
      {/* header */}
      <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between", gap:10, padding:"4px 20px 12px" }}>
        <LiveTicker items={tickerItems} onOpen={(item)=>{
          if (item.target === "play") { !disabled && onPlay && onPlay(); return; }
          if (item.target === "baku") { onBakuFocus ? onBakuFocus(15) : onNav("baku"); return; }
          onNav(item.target);
        }} />
        <LangToggle lang={lang} onLang={()=>onNav("__lang")} />
      </div>

      {/* hero */}
      <div style={{ padding:"0 16px" }}>
        <div style={{ position:"relative", borderRadius:"var(--r-xl)", overflow:"hidden", background:"var(--grad-kv)", padding:"20px 20px 22px", minHeight:230 }}>
          <VideoBg src={VID} poster={POSTER} style={{ right:"-4%", top:"-8px", width:"72%", height:"auto", maxHeight:"86%", WebkitMaskImage:"radial-gradient(110% 130% at 76% 26%, #000 16%, rgba(0,0,0,0.5) 52%, rgba(0,0,0,0) 90%)", maskImage:"radial-gradient(110% 130% at 76% 26%, #000 16%, rgba(0,0,0,0.5) 52%, rgba(0,0,0,0) 90%)" }} />
          <div style={{ position:"absolute", inset:0, background:"linear-gradient(90deg, var(--brand-dark) 0%, rgba(158,26,14,.62) 24%, rgba(158,26,14,.18) 56%, rgba(158,26,14,0) 100%)", pointerEvents:"none" }} />
          <div style={{ position:"relative" }}>
            <Eyebrow color="rgba(255,255,255,.8)">{l.hello}, {displayName}</Eyebrow>
            <div style={{ marginTop:10 }}><StatHero value={showPoints ? points : (ps.attempts || 0)} label={showPoints ? l.points : l.attempts_label} /></div>
            <div style={{ marginTop:8, fontFamily:"var(--font-body)", fontSize:12, color:"rgba(255,255,255,.76)" }}>
              {showPoints ? l.home_prizes : l.attempts_help}
            </div>
            <div style={{ marginTop:16 }}>
              {/* the 1-2-3 rule reminder stays for everyone */}
              <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between", gap:8, marginBottom:10 }}>
                {[l.step1, l.step2, l.step3].map((s,i)=>(
                  <div key={i} style={{ flex:"none", display:"flex", alignItems:"center", gap:6 }}>
                    <span style={{ width:20, height:20, flex:"none", borderRadius:"50%", background:i===1?"var(--grad-red)":"rgba(255,255,255,.16)", color:"#fff", fontFamily:"var(--font-heading)", fontSize:11, display:"flex", alignItems:"center", justifyContent:"center" }}>{i+1}</span>
                    <span style={{ fontFamily:"var(--font-heading)", fontSize:10, color:"rgba(255,255,255,.85)", textTransform:"uppercase", whiteSpace:"nowrap" }}>{s}</span>
                  </div>
                ))}
              </div>
              {phase === "announced" ? (
                /* A: announced - start time + racing-board countdown + team call */
                <div style={{ width:"100%", boxSizing:"border-box", borderRadius:"var(--r-lg)", padding:"14px 16px", background:"rgba(0,0,0,.32)", border:"1px solid var(--border-strong)" }}>
                  <div style={{ display:"flex", alignItems:"baseline", justifyContent:"space-between", gap:10 }}>
                    <span style={{ fontFamily:"var(--font-heading)", fontSize:15, color:"#fff", textTransform:"uppercase" }}>{l.ann_title}</span>
                    <span style={{ fontFamily:"var(--font-heading)", fontSize:13, color:"var(--sting-gold)", textTransform:"uppercase" }}>{l.ann_start(fmtHhMmTashkent(win.startsAt))}</span>
                  </div>
                  <div style={{ marginTop:8 }}>
                    <CountdownDigits targetIso={win.startsAt} nowMs={nowMs} label={l.ann_countdown} />
                  </div>
                  {team && (
                    ps.callUsed
                      ? <div style={{ marginTop:12, textAlign:"center", fontFamily:"var(--font-body)", fontSize:12, color:"rgba(255,255,255,.65)" }}>{l.call_done}</div>
                      : callAllowed && (
                          <div style={{ marginTop:12 }}>
                            <BigButton actionId="team:call" icon="users" onClick={onCall}>{l.call_team}</BigButton>
                          </div>
                        )
                  )}
                  <button data-ui-action="game:practice" onClick={onPractice} style={{ width:"100%", marginTop:10, background:"transparent", border:"none", cursor:"pointer", color:"rgba(255,255,255,.7)", fontFamily:"var(--font-body)", fontSize:13, fontWeight:600 }}>{l.practice_t} · {l.gi_cta}</button>
                </div>
              ) : played && win ? (
                /* C: played today - own result + time left while the window runs */
                <div style={{ width:"100%", boxSizing:"border-box", borderRadius:"var(--r-lg)", padding:"14px 16px", background:"rgba(0,0,0,.32)", border:"1px solid var(--border-strong)" }}>
                  <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between", gap:10 }}>
                    <span style={{ fontFamily:"var(--font-heading)", fontSize:12, color:"rgba(255,255,255,.75)", textTransform:"uppercase" }}>{l.your_result}</span>
                    {ownRow && ownRow.multiplier > 1 && <span style={{ fontFamily:"var(--font-heading)", fontSize:11, color:"#000", background:"var(--grad-gold)", borderRadius:"var(--r-pill)", padding:"3px 9px" }}>×2</span>}
                  </div>
                  <div style={{ marginTop:6, display:"flex", alignItems:"baseline", gap:10 }}>
                    <span style={{ fontFamily:"var(--font-display)", fontWeight:900, fontSize:32, lineHeight:1, color:"#fff" }}>{ownRow ? (ownRow.elapsedMs / 1000).toFixed(2) : "--"}</span>
                    <span style={{ fontFamily:"var(--font-heading)", fontSize:13, color:"rgba(255,255,255,.8)" }}>{l.sec}</span>
                  </div>
                  {phase === "live" && (
                    <>
                      <div style={{ marginTop:8, fontFamily:"var(--font-body)", fontSize:12, color:"rgba(255,255,255,.7)" }}>{l.live_left(minutesLeft(win.endsAt, nowMs))}</div>
                      <TimeLeftBar startsAt={win.startsAt} endsAt={win.endsAt} nowMs={nowMs} />
                    </>
                  )}
                  {callAllowed && (
                    <div style={{ marginTop:12 }}>
                      <BigButton actionId="team:call" icon="users" onClick={onCall}>{l.call_team}</BigButton>
                    </div>
                  )}
                </div>
              ) : canPlay ? (
                /* B: live (or demo fallback) - pulsing play card + depleting time bar */
                <>
                  <button data-ui-action="game:play" aria-disabled={disabled ? "true" : "false"} onClick={(event)=>{ if (disabled) { event.preventDefault(); return; } onPlay?.(); }} className="tilepress ctapulse" style={{ width:"100%", boxSizing:"border-box", border:"none", cursor:disabled?"not-allowed":"pointer", borderRadius:"var(--r-lg)", padding:"14px 16px", background:"#fff", display:"flex", alignItems:"center", justifyContent:"space-between", transition:"transform .12s", opacity:disabled ? .72 : 1 }}>
                    <span style={{ textAlign:"left" }}>
                      <span style={{ display:"block", fontFamily:"var(--font-heading)", fontSize:15, color:"#000", textTransform:"uppercase" }}>{l.live_t}</span>
                      <span style={{ display:"block", fontFamily:"var(--font-body)", fontSize:12, color:"var(--ink-500)" }}>{win ? l.live_left(minutesLeft(win.endsAt, nowMs)) : l.pit_sub}</span>
                    </span>
                    <span style={{ width:38, height:38, flex:"none", borderRadius:"50%", background:"var(--grad-red)", display:"flex", alignItems:"center", justifyContent:"center" }}><Icon name="flag" size={19} color="#fff" /></span>
                  </button>
                  {win && <TimeLeftBar startsAt={win.startsAt} endsAt={win.endsAt} nowMs={nowMs} />}
                </>
              ) : (
                /* D/E: a live window without attempts opens the exact explanation; otherwise practice. */
                <button data-ui-action={phase === "live" && !played ? "game:play_without_attempt" : "game:practice"} onClick={phase === "live" && !played ? onPlay : onPractice} className="tilepress" style={{ width:"100%", boxSizing:"border-box", cursor:"pointer", borderRadius:"var(--r-lg)", padding:"14px 16px", background:"rgba(255,255,255,.08)", border:"1px dashed var(--border-strong)", display:"flex", alignItems:"center", justifyContent:"space-between", transition:"transform .12s" }}>
                  <span style={{ textAlign:"left" }}>
                    <span style={{ display:"block", fontFamily:"var(--font-heading)", fontSize:15, color:"rgba(255,255,255,.85)", textTransform:"uppercase" }}>{phase === "live" && !played ? l.no_attempts_title : l.practice_t}</span>
                    <span style={{ display:"block", fontFamily:"var(--font-body)", fontSize:12, color:"rgba(255,255,255,.6)" }}>
                      {phase === "live" && !played ? l.no_attempts_body : phase === "closed" ? l.closed_today : played ? l.pit_done_sub : l.practice_sub}
                    </span>
                    {!win && <span style={{ display:"block", marginTop:2, fontFamily:"var(--font-body)", fontSize:11, color:"rgba(255,255,255,.45)" }}>{l.no_window_hint}</span>}
                  </span>
                  <span style={{ width:38, height:38, flex:"none", borderRadius:"50%", background:"rgba(214,35,0,.4)", display:"flex", alignItems:"center", justifyContent:"center" }}><Icon name="flag" size={19} color="rgba(255,255,255,.85)" /></span>
                </button>
              )}
            </div>
          </div>
        </div>
      </div>

      {storySharing && team && win && phase !== "closed" && (
        <div style={{ padding:"12px 16px 0" }}>
          <BigButton actionId="story:rally" icon="share" onClick={onStoryRally} disabled={disabled}>{l.story_rally}</BigButton>
        </div>
      )}

      {/* today's team leaderboard (live and after) */}
      {win && phase !== "announced" && results.length > 0 && (
        <div style={{ padding:"14px 16px 0" }}>
          <div style={{ borderRadius:"var(--r-xl)", background:"var(--surface-card)", border:"1px solid var(--border-subtle)", padding:"14px 16px" }}>
            <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between", marginBottom:8 }}>
              <span style={{ fontFamily:"var(--font-heading)", fontSize:13, color:"var(--text-strong)", textTransform:"uppercase" }}>{l.lb_title}</span>
              {team && <span style={{ fontFamily:"var(--font-body)", fontSize:12, fontWeight:700, color: team.boostActive ? "var(--success)" : "var(--sting-gold)" }}>{teamBoostProgress(team).text} {team.boostActive ? "×2" : ""}</span>}
            </div>
            <LeaderboardTable rows={results} youId={user?.id} l={l} mini showPoints={showPoints} />
            {team && !team.boostActive && (
              <div style={{ marginTop:8, fontFamily:"var(--font-body)", fontSize:11, lineHeight:1.4, color:"var(--text-muted)" }}>{l.x2_note}</div>
            )}
          </div>
        </div>
      )}

      {/* team boost */}
      <div style={{ padding:"14px 16px 0" }}>
        <button data-ui-action="home:open_team" onClick={()=>onNav("team")} className="tilepress" style={{ width:"100%", border:"1px solid var(--border-subtle)", background:"var(--surface-card)", cursor:"pointer", borderRadius:"var(--r-xl)", padding:"16px 18px", display:"flex", alignItems:"center", gap:14, transition:"transform .12s" }}>
          <Icon name="fuel" size={30} color="var(--brand)" />
          <div style={{ flex:1, textAlign:"left" }}>
            <div style={{ display:"flex", alignItems:"baseline", gap:8 }}>
              <span style={{ fontFamily:"var(--font-display)", fontWeight:900, fontSize:30, color:"var(--text-strong)" }}>{teamBoostProgress(team).text}</span>
              <span style={{ fontFamily:"var(--font-heading)", fontSize:12, color:"var(--text-muted)", textTransform:"uppercase" }}>{l.tank}</span>
            </div>
            <div style={{ fontFamily:"var(--font-body)", fontSize:12, color:"var(--text-muted)", marginTop:2 }}>{boostText} · {l.tank_sub}</div>
          </div>
          <Icon name="chevron" size={20} color="var(--text-muted)" />
        </button>
      </div>

      {/* actions - scan lives in the bottom nav; this row is rules + tickets */}
      <div style={{ display:"flex", gap:12, padding:"12px 16px 22px" }}>
        <Tile actionId="home:rules" icon="help" title={l.rules_tile} hint={l.rules_hint} onClick={()=>onNav("rules")} />
        <Tile actionId="home:tickets" icon="ticket" title={l.tickets_tile} hint={tickets+" "+l.in_game} onClick={()=>onNav("tickets")} />
      </div>
    </div>
  );
}

function LangToggle({ lang, onLang }) {
  return (
    <button data-ui-action="language:toggle" onClick={onLang} style={{ border:"1px solid var(--border-subtle)", background:"var(--surface-card)", cursor:"pointer", borderRadius:"var(--r-pill)", padding:"5px 11px", display:"flex", alignItems:"center", gap:6 }}>
      <Icon name="globe" size={14} color="var(--text-muted)" />
      <span style={{ fontFamily:"var(--font-heading)", fontSize:12, color:"var(--text-strong)" }}>{lang==="uz"?"UZ":"RU"}</span>
    </button>
  );
}

/* Live ticker: rotates personal + campaign facts. Cold-start honest by design -
   no fabricated winner events; real feed items can be appended later. */
function LiveTicker({ items, onOpen }) {
  const [idx, setIdx] = React.useState(0);
  React.useEffect(() => {
    if (items.length <= 1) return undefined;
    const t = window.setInterval(() => setIdx((v) => v + 1), 4000);
    return () => window.clearInterval(t);
  }, [items.length]);
  const item = items[idx % items.length];
  return (
    <button data-ui-action={`ticker:${item.actionId}`} onClick={()=>onOpen(item)} className="tilepress" style={{ flex:1, maxWidth:260, minWidth:0, border:"1px solid var(--border-subtle)", background:"var(--surface-card)", cursor:"pointer", borderRadius:"var(--r-pill)", padding:"6px 10px 6px 7px", display:"flex", alignItems:"center", gap:8, overflow:"hidden" }}>
      <span style={{ width:32, height:32, flex:"0 0 32px", borderRadius:"50%", background:item.gold?"var(--sting-gold)":"var(--grad-red)", display:"flex", alignItems:"center", justifyContent:"center", boxShadow:"0 0 16px rgba(214,35,0,.34)" }}><Icon name={item.icon} size={16} color={item.gold?"#000":"#fff"} /></span>
      <span key={idx % items.length} style={{ minWidth:0, display:"block", textAlign:"left", animation:"fadeIn .3s ease both" }}>
        <span style={{ display:"block", fontFamily:"var(--font-heading)", fontSize:10, color:"var(--sting-gold)", textTransform:"uppercase", lineHeight:1 }}>{item.tag}</span>
        <span style={{ display:"block", fontFamily:"var(--font-heading)", fontSize:12, color:"var(--text-strong)", textTransform:"uppercase", whiteSpace:"nowrap", overflow:"hidden", textOverflow:"ellipsis", lineHeight:1.15, marginTop:2 }}>{withSting(item.title)}</span>
      </span>
    </button>
  );
}

/* ---------- TEAM ---------- */
/* "Как работает удвоение" - opens the same-day x2 explainer (v9: the boost only
   mirrors receipts of the day the player actually finished the mini-game).
   Rendered as a plain button so it never nests inside another interactive tile. */
function X2HowLink({ lang, onInfo, style }) {
  const l = L(lang);
  if (typeof onInfo !== "function") return null;
  return (
    <button
      data-ui-action="team:how_x2"
      type="button"
      onClick={() => onInfo("teamX2")}
      style={Object.assign({
        display:"flex", alignItems:"center", gap:8, width:"100%",
        padding:"10px 12px", borderRadius:"var(--r-lg)",
        background:"transparent", border:"1px solid var(--border-subtle)",
        color:"var(--sting-gold)", fontFamily:"var(--font-body)", fontSize:12,
        cursor:"pointer", textAlign:"left", minHeight:40,
      }, style || {})}
    >
      <Icon name="help" size={14} color="var(--sting-gold)" />
      <span>{l.x2_how}</span>
    </button>
  );
}

function TeamScreen({ lang, state, onChangeTeam, onInvite, onCall, onCreateTeam, onStoryRally, onInfo, storySharing, disabled }) {
  const l = L(lang);
  const team = state?.team;
  const ps = state?.pitStop || {};
  const win = ps.window || null;
  const nowMs = useNowTicker(Boolean(win), ps.serverNow);
  const phase = phaseOf(win, nowMs);
  const results = ps.results || [];
  const callVisible = !!win && phase !== "closed";
  const userName = state?.user?.name || l.you;
  const maxMembers = team?.maxMembers ?? 20;
  const members = (team?.members || []).map((m)=>({
    name:m.name || (m.id === state?.user?.id ? userName : l.member),
    tickets: m.ticketCount || 0,
    captain:m.id===team.captainUserId,
    you:m.id===state?.user?.id,
    played:!!m.playedCurrentWindow,
  })) || [];
  if (!team) {
    return (
      <div style={{ flex:1, overflowY:"auto", background:"var(--surface-base)", padding:"4px 20px 24px" }}>
        <Eyebrow>{l.solo_mode}</Eyebrow>
        <H1>{l.team_title}</H1>
        <div style={{ marginTop:18, borderRadius:"var(--r-xl)", background:"var(--surface-card)", border:"1px solid var(--border-subtle)", padding:"20px" }}>
          <VisualCrop src={approvedKv(lang)} height={150} position="top" style={{ marginBottom:14 }} />
          <div style={{ marginTop:14, fontFamily:"var(--font-heading)", fontSize:18, color:"#fff", textTransform:"uppercase" }}>{l.solo_can}</div>
          <p style={{ margin:"8px 0 12px", fontFamily:"var(--font-body)", fontSize:14, lineHeight:1.45, color:"var(--text-muted)" }}>{l.solo_desc}</p>
          <X2HowLink lang={lang} onInfo={onInfo} style={{ marginBottom:14 }} />
          <BigButton actionId="team:create" icon="users" onClick={onCreateTeam} disabled={disabled}>{l.create_team}</BigButton>
        </div>
      </div>
    );
  }
  return (
    <div style={{ flex:1, overflowY:"auto", background:"var(--surface-base)", padding:"4px 20px 24px" }}>
      <Eyebrow>{team.name}</Eyebrow>
      <H1>{l.team_title}</H1>
      <HintLine text={l.hint_team} />
      <div style={{ marginTop:16, borderRadius:"var(--r-xl)", background:"var(--grad-kv)", padding:"18px 20px", display:"flex", alignItems:"center", gap:14 }}>
        <Icon name="fuel" size={34} color="#fff" />
        <div>
          <div style={{ display:"flex", alignItems:"baseline", gap:8 }}>
            <span style={{ fontFamily:"var(--font-display)", fontWeight:900, fontSize:40, color:"#fff" }}>{teamBoostProgress(team).text}</span>
            <span style={{ fontFamily:"var(--font-heading)", fontSize:12, color:"rgba(255,255,255,.8)", textTransform:"uppercase" }}>{team?.boostActive ? l.boost_on : l.boost_to}</span>
          </div>
          <div style={{ fontFamily:"var(--font-body)", fontSize:12, color:"rgba(255,255,255,.85)" }}>{l.need_more}</div>
        </div>
      </div>
      <X2HowLink lang={lang} onInfo={onInfo} style={{ marginTop:10 }} />

      {/* today's window leaderboard */}
      {win && phase !== "announced" && results.length > 0 && (
        <div style={{ marginTop:16, borderRadius:"var(--r-xl)", background:"var(--surface-card)", border:"1px solid var(--border-subtle)", padding:"14px 16px" }}>
          <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between", marginBottom:8 }}>
            <span style={{ fontFamily:"var(--font-heading)", fontSize:13, color:"var(--text-strong)", textTransform:"uppercase" }}>{l.lb_title}</span>
            {phase === "live" && <span style={{ fontFamily:"var(--font-body)", fontSize:12, fontWeight:700, color:"var(--sting-gold)" }}>{l.live_left(minutesLeft(win.endsAt, nowMs))}</span>}
          </div>
          <LeaderboardTable rows={results} youId={state?.user?.id} l={l} showPoints={state?.currentTour?.mechanics?.showPoints ?? true} />
          {!team.boostActive && (
            <div style={{ marginTop:8, fontFamily:"var(--font-body)", fontSize:11, lineHeight:1.4, color:"var(--text-muted)" }}>{l.x2_note}</div>
          )}
        </div>
      )}
      {win && phase === "announced" && (
        <div style={{ marginTop:16, borderRadius:"var(--r-xl)", background:"var(--surface-card)", border:"1px solid var(--border-subtle)", padding:"14px 16px", display:"flex", alignItems:"center", gap:10 }}>
          <Icon name="clock" size={18} color="var(--sting-gold)" />
          <span style={{ fontFamily:"var(--font-body)", fontSize:13, color:"var(--text-body)" }}>{l.ann_title} · {l.ann_start(fmtHhMmTashkent(win.startsAt))}</span>
        </div>
      )}

      <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", margin:"20px 0 10px" }}>
        <span style={{ fontFamily:"var(--font-heading)", fontSize:14, color:"var(--text-strong)", textTransform:"uppercase" }}>{members.length}/{maxMembers} · {l.members}</span>
        <span style={{ fontFamily:"var(--font-body)", fontSize:12, color:team?.boostActive?"var(--success)":"var(--sting-gold)", fontWeight:700 }}>{team?.boostActive ? "x2" : `${lang === "uz" ? "yana" : "ещё"} ${team?.missingForBoost ?? teamBoostThreshold(team)}`}</span>
      </div>
      <div style={{ display:"flex", flexDirection:"column", gap:8 }}>
        {members.map((m,i)=>(
          <div key={i} style={{ display:"flex", alignItems:"center", gap:12, padding:"11px 14px", borderRadius:"var(--r-md)", background:m.you?"var(--ink-700)":"transparent", border:m.you?"1px solid var(--brand)":"1px solid var(--border-subtle)" }}>
            <span style={{ width:22, fontFamily:"var(--font-heading)", fontSize:14, color:"var(--text-muted)" }}>{i+1}</span>
            <span style={{ flex:1, fontFamily:"var(--font-body)", fontSize:14, fontWeight:700, color:"var(--text-strong)" }}>
              {m.name}{m.captain && <span style={{ marginLeft:8, fontFamily:"var(--font-heading)", fontSize:10, color:"var(--sting-gold)", textTransform:"uppercase" }}>{l.captain}</span>}
            </span>
            <span style={{ fontFamily:"var(--font-body)", fontSize:11, color:m.played?"var(--success)":"var(--text-muted)", textTransform:"uppercase" }}>{m.played?l.played:l.waiting}</span>
            <span style={{ display:"flex", alignItems:"center", gap:5 }}>
              <Icon name="ticket" size={14} color="var(--brand)" />
              <span style={{ fontFamily:"var(--font-heading)", fontSize:14, color:"var(--text-strong)" }}>{m.tickets}</span>
            </span>
          </div>
        ))}
      </div>
      <div style={{ marginTop:18 }}><BigButton actionId="team:invite" icon="share" onClick={onInvite} disabled={disabled}>{l.invite}</BigButton></div>
      <div style={{ marginTop:8, display:"flex", gap:8, alignItems:"flex-start", fontFamily:"var(--font-body)", fontSize:12, lineHeight:1.4, color:"var(--text-muted)" }}>
        <Icon name="gift" size={15} color="var(--sting-gold)" style={{ flex:"0 0 15px", marginTop:1 }} />
        <span>{l.invite_benefit}</span>
      </div>
      {callVisible && (
        ps.callUsed
          ? <div style={{ marginTop:10, height:54, borderRadius:"var(--r-lg)", border:"1px solid var(--border-subtle)", display:"flex", alignItems:"center", justifyContent:"center", color:"var(--text-muted)", fontFamily:"var(--font-heading)", fontSize:14, textTransform:"uppercase" }}>{l.call_done}</div>
          : <div style={{ marginTop:10 }}><BigButton actionId="team:call" icon="flag" onClick={onCall} disabled={disabled}>{l.call_team}</BigButton></div>
      )}
      {storySharing && win && phase !== "closed" && (
        <div style={{ marginTop:10 }}><BigButton actionId="story:rally" icon="share" onClick={onStoryRally} disabled={disabled}>{l.story_rally}</BigButton></div>
      )}
      {!win && <div style={{ marginTop:10 }}><BigButton actionId="team:call" icon="flag" onClick={onCall} disabled={disabled}>{l.call_team}</BigButton></div>}
      <button data-ui-action="team:change" aria-disabled={disabled ? "true" : "false"} onClick={(event)=>{ if (disabled) { event.preventDefault(); return; } onChangeTeam?.(); }} style={{ width:"100%", marginTop:12, background:"transparent", border:"none", cursor:disabled?"not-allowed":"pointer", color:"var(--text-muted)", fontFamily:"var(--font-body)", fontSize:13, fontWeight:600, opacity:disabled ? .72 : 1 }}>{l.leave}</button>
    </div>
  );
}

/* ---------- BAKU PRIZE ---------- */
const stripMd = (s) => (s || "").replace(/^#+\s*/gm, "").replace(/\*\*/g, "").trim();

function Fact({ k, v }) {
  if (!v) return null;
  return (
    <div style={{ flex:1, minWidth:64, textAlign:"center" }}>
      <div style={{ fontFamily:"var(--font-display)", fontWeight:900, fontSize:20, color:"#fff", lineHeight:1 }}>{v}</div>
      <div style={{ fontFamily:"var(--font-body)", fontSize:10, fontWeight:700, textTransform:"uppercase", letterSpacing:"0.05em", color:"var(--text-muted)", marginTop:3 }}>{k}</div>
    </div>
  );
}

function RaceRow({ race, open, onToggle, lang }) {
  const l = L(lang);
  const win = (race.podium || [])[0];
  const gold = race.highlight;
  return (
    <div style={{ borderRadius:"var(--r-md)", border:`1px solid ${gold?"var(--sting-gold)":"var(--border-subtle)"}`, overflow:"hidden", background: gold?"rgba(212,160,23,.06)":"transparent" }}>
      <button data-ui-action={`baku:race:${race.round}`} onClick={onToggle} onPointerDown={(e)=>J.cta(e.currentTarget)} style={{ width:"100%", display:"flex", alignItems:"center", gap:12, padding:"11px 14px", background:"transparent", border:"none", cursor:"pointer", textAlign:"left" }}>
        <Icon name={gold?"trophy":(win?"flag":"flag")} size={18} color={gold?"var(--sting-gold)":(win?"var(--success)":"var(--brand)")} />
        <div style={{ flex:1, minWidth:0 }}>
          <div style={{ fontFamily:"var(--font-body)", fontSize:14, fontWeight:700, color:"var(--text-strong)" }}>R{race.round} · {race.country}{gold && <span style={{ color:"var(--sting-gold)", fontFamily:"var(--font-heading)", fontSize:10, marginLeft:8 }}>{l.your_prize}</span>}</div>
          <div style={{ fontFamily:"var(--font-body)", fontSize:11, color:"var(--text-muted)", overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }}>{win ? win.driver : race.circuit}</div>
        </div>
        <span style={{ fontFamily:"var(--font-body)", fontSize:12, color:"var(--text-muted)" }}>{race.dates}</span>
        <span style={{ display:"flex", transform:open?"rotate(90deg)":"rotate(0deg)", transition:"transform .25s cubic-bezier(.22,1,.36,1)" }}><Icon name="chevron" size={16} color="var(--text-muted)" /></span>
      </button>
      {open && (
        <div style={{ padding:"0 14px 16px" }}>
          {race.circuitMapImageUrl && (
            <div style={{ background:"#0d0406", borderRadius:"var(--r-md)", padding:"10px", marginBottom:12 }}>
              <img src={race.circuitMapImageUrl} alt={race.circuit} loading="lazy" referrerPolicy="no-referrer" style={{ width:"100%", height:140, objectFit:"contain" }} />
            </div>
          )}
          <div style={{ fontFamily:"var(--font-heading)", fontSize:13, color:"#fff", textTransform:"uppercase", marginBottom:8 }}>{race.circuit}</div>
          <div style={{ display:"flex", gap:8, marginBottom:12 }}>
            <Fact k={l.fact_km} v={race.circuitLengthKm} />
            <Fact k={l.fact_laps} v={race.laps} />
            <Fact k={l.fact_turns} v={race.turns} />
            {race.lapRecord && race.lapRecord.time ? <Fact k={l.fact_record} v={race.lapRecord.time} /> : null}
          </div>
          {race.immersionFactRu && <div style={{ fontFamily:"var(--font-body)", fontSize:13, lineHeight:1.5, color:"var(--text-body)", marginBottom: (race.podium||[]).length?12:0 }}>{race.immersionFactRu}</div>}
          {(race.podium || []).length > 0 && (
            <div style={{ borderTop:"1px solid var(--border-subtle)", paddingTop:10 }}>
              {race.podium.map((p,i)=>(
                <div key={i} style={{ display:"flex", alignItems:"center", gap:10, padding:"4px 0" }}>
                  <span style={{ width:20, fontFamily:"var(--font-heading)", fontSize:13, color:i===0?"var(--sting-gold)":"var(--text-muted)" }}>P{p.position}</span>
                  <span style={{ flex:1, fontFamily:"var(--font-body)", fontSize:13, fontWeight:i===0?700:600, color:i===0?"#fff":"var(--text-body)" }}>{p.driver}</span>
                  <span style={{ fontFamily:"var(--font-body)", fontSize:11, color:"var(--text-muted)" }}>{p.team}</span>
                </div>
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
}

function ArticleImage({ img }) {
  if (!img || !img.url) return null;
  return (
    <figure style={{ margin:"14px 0" }}>
      <img src={img.url} alt={img.caption || ""} loading="lazy" referrerPolicy="no-referrer" style={{ width:"100%", borderRadius:"var(--r-md)", display:"block", background:"#0d0406" }} />
      {img.caption && <figcaption style={{ marginTop:6, fontFamily:"var(--font-body)", fontSize:11, color:"var(--text-muted)", lineHeight:1.4 }}>{img.caption}</figcaption>}
    </figure>
  );
}

function ArticleBody({ body, images }) {
  const paras = stripMd(body).split(/\n\n+/).filter(Boolean);
  const imgs = images || [];
  return (
    <div>
      {paras.map((para,i)=>(
        <React.Fragment key={i}>
          <p style={{ margin:"0 0 10px", fontFamily:"var(--font-body)", fontSize:13, lineHeight:1.6, color:"var(--text-body)" }}>{para}</p>
          {imgs[i] && <ArticleImage img={imgs[i]} />}
        </React.Fragment>
      ))}
      {imgs.slice(paras.length).map((img,i)=>(<ArticleImage key={"x"+i} img={img} />))}
    </div>
  );
}

function ImmersionCard({ block, open, onToggle }) {
  if (!block) return null;
  return (
    <div style={{ borderRadius:"var(--r-xl)", border:"1px solid var(--border-subtle)", background:"var(--surface-card)", overflow:"hidden", marginBottom:10 }}>
      <button data-ui-action={`baku:article:${block.id || "current"}`} onClick={onToggle} onPointerDown={(e)=>J.cta(e.currentTarget)} style={{ width:"100%", display:"flex", alignItems:"center", gap:12, padding:"15px 16px", background:"transparent", border:"none", cursor:"pointer", textAlign:"left" }}>
        <Icon name="flag" size={18} color="var(--brand)" />
        <span style={{ flex:1, fontFamily:"var(--font-heading)", fontSize:14, color:"var(--text-strong)", textTransform:"uppercase" }}>{block.titleRu}</span>
        <span style={{ display:"flex", transform:open?"rotate(90deg)":"rotate(0deg)", transition:"transform .25s cubic-bezier(.22,1,.36,1)" }}><Icon name="chevron" size={18} color="var(--text-muted)" /></span>
      </button>
      {open && (
        <div style={{ padding:"0 16px 18px" }}>
          {(block.pullQuotesRu || []).slice(0,2).map((q,i)=>(
            <div key={i} style={{ borderLeft:"3px solid var(--brand)", paddingLeft:12, margin:"0 0 12px", fontFamily:"var(--font-body)", fontStyle:"italic", fontSize:14, lineHeight:1.5, color:"#fff" }}>{q}</div>
          ))}
          <ArticleBody body={block.bodyRu} images={block.images} />
          {block.stingBridgeRu && <div style={{ marginTop:14, paddingTop:12, borderTop:"1px solid var(--border-subtle)", fontFamily:"var(--font-body)", fontSize:13, fontWeight:700, color:"var(--sting-gold)" }}>{block.stingBridgeRu}</div>}
        </div>
      )}
    </div>
  );
}

function BakuScreen({ lang, state, focusRound=15, onRules }) {
  const l = L(lang);
  const [manifestOpen, setManifestOpen] = React.useState(false);
  const ticketCount = state?.ticketCount ?? (state?.tickets || []).length;

  return (
    <div style={{ flex:1, overflowY:"auto", background:"var(--surface-base)", padding:"4px 20px 28px" }}>
      <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between", gap:10 }}>
        <Eyebrow>{l.baku_eyebrow}</Eyebrow>
        <F1Logo height={16} />
      </div>
      <HintLine text={l.hint_baku} />

      {/* prize manifest (collapsible) */}
      <div style={{ marginTop:16, borderRadius:"var(--r-xl)", background:"var(--surface-card)", border:"1px solid var(--border-subtle)", padding:"18px 18px 16px" }}>
        <button
          data-ui-action="baku:manifest"
          type="button"
          onClick={()=>setManifestOpen(v=>!v)}
          aria-expanded={manifestOpen}
          aria-controls="baku-trip-manifest"
          style={{ width:"100%", minHeight:44, display:"flex", alignItems:"center", gap:10, background:"transparent", border:"none", cursor:"pointer", textAlign:"left", padding:0 }}
        >
          <span style={{ flex:1, fontFamily:"var(--font-heading)", fontSize:17, color:"#fff", textTransform:"uppercase", lineHeight:1.15 }}>{l.baku_collect}</span>
          <Icon name="chevron" size={18} color="var(--text-muted)" />
        </button>
        {manifestOpen && (
          <div id="baku-trip-manifest" style={{ margin:"10px 0 0" }}>
            <p style={{ margin:0, fontFamily:"var(--font-body)", fontSize:13, lineHeight:1.6, color:"var(--text-body)" }}>
              {withSting(l.baku_manifest)}
            </p>
            {onRules ? (
              <button data-ui-action="baku:rules" type="button" onClick={onRules} style={{ marginTop:12, minHeight:44, padding:"0 14px", borderRadius:12, border:"1px solid var(--sting-gold)", background:"transparent", color:"var(--sting-gold)", fontFamily:"var(--font-heading)", fontSize:12, textTransform:"uppercase", cursor:"pointer" }}>
                {l.baku_rules}
              </button>
            ) : null}
          </div>
        )}
      </div>

      {/* Approved prize spotlight; KV stays unchanged. */}
      <div style={{ marginTop:16, borderRadius:"var(--r-xl)", overflow:"hidden", border:"1px solid var(--sting-gold)" }}>
        <img src={approvedKv(lang)} alt="" loading="lazy" aria-hidden="true" style={{ width:"100%", height:220, objectFit:"cover", objectPosition:"center", display:"block", background:"var(--ink-900)" }} />
        <div style={{ padding:"16px 18px", background:"var(--surface-card)" }}>
          <div style={{ fontFamily:"var(--font-display)", fontWeight:900, fontSize:34, color:"#fff", lineHeight:.9 }}>{l.baku_collect}</div>
          <div style={{ marginTop:8, fontFamily:"var(--font-body)", fontSize:13, fontWeight:600, color:"var(--sting-gold)" }}>{l.baku_trip_dates}</div>
          <div style={{ display:"flex", alignItems:"center", gap:8, marginTop:14 }}>
            <Icon name="ticket" size={20} color="var(--brand)" />
            <span style={{ fontFamily:"var(--font-body)", fontSize:13, color:"var(--text-body)" }}>{lang === "uz" ? `${l.prize_main} uchun ${ticketCount} ta shaxsiy ${chanceWord(ticketCount, lang)}` : `${ticketCount} личных ${chanceWord(ticketCount, lang)} на главный приз`}</span>
          </div>
          <p style={{ margin:"14px 0 0", fontFamily:"var(--font-body)", fontSize:13, lineHeight:1.6, color:"var(--text-body)" }}>
            {withSting(l.prize_desc)} {withSting(l.baku_more_tail)}
          </p>
        </div>
      </div>
    </div>
  );
}

/* ---------- CABINET (личный кабинет) ---------- */
function CabinetScreen({ points, onNav, onLogout, lang, state, onInfo, onEditProfile, onTutorial }) {
  const l = L(lang);
  const [soundOn, setSoundOn] = React.useState(!Snd.isMuted());
  const displayName = state?.user?.name || (lang === "uz" ? "Ishtirokchi" : "Участник");
  const profileLine = state?.team?.name || l.solo_mode;
  const rows = [
    { actionId:"cabinet:edit_profile", icon:"user", label:l.name_team, sub: displayName, go:onEditProfile },
    { actionId:"cabinet:team", icon:"users", label:l.nav_team, go:()=>onNav("team") },
    { actionId:"cabinet:baku", icon:"flag", label:l.nav_baku, go:()=>onNav("baku") },
    { actionId:"cabinet:tickets", icon:"ticket", label:l.my_tickets, go:()=>onNav("tickets") },
    { actionId:"cabinet:prizes", icon:"gift", label:l.payout_status, go:()=>onInfo("prizes") },
    { actionId:"cabinet:language", icon:"globe", label:l.language, sub: lang==="uz"?"Oʻzbekcha":"Русский", go:()=>onNav("__lang") },
    { actionId:"cabinet:sound", icon:"volume", label:l.sound, sub: soundOn ? l.sound_on : l.sound_off, go:()=>{ Snd.setMuted(soundOn); setSoundOn(!soundOn); } },
    { actionId:"cabinet:tutorial", icon:"help", label:l.howto, go:onTutorial },
    { actionId:"cabinet:rules", icon:"file", label:l.rules, go:()=>onNav("rules") },
    { actionId:"cabinet:offer", icon:"shield", label:l.offer, go:()=>onInfo("offer") },
    { actionId:"cabinet:support", icon:"help", label:l.support, go:()=>onInfo("support") },
  ];
  return (
    <div style={{ flex:1, overflowY:"auto", background:"var(--surface-base)" }}>
      <div style={{ position:"relative", padding:"10px 20px 18px", background:"var(--grad-kv)" }}>
        <div style={{ display:"flex", alignItems:"center", gap:14 }}>
          <div style={{ width:64, height:64, borderRadius:"50%", background:"rgba(0,0,0,.3)", border:"2px solid rgba(255,255,255,.4)", display:"flex", alignItems:"center", justifyContent:"center" }}><Icon name="user" size={30} color="#fff" /></div>
          <div>
            <div style={{ fontFamily:"var(--font-heading)", fontSize:20, color:"#fff", textTransform:"uppercase" }}>{displayName}</div>
          <div style={{ fontFamily:"var(--font-body)", fontSize:13, color:"rgba(255,255,255,.85)" }}>{profileLine} · {l.level}</div>
          </div>
        </div>
        <div style={{ display:"flex", gap:10, marginTop:16 }}>
          {[
            ...((state?.currentTour?.mechanics?.showPoints ?? true) ? [{k:l.points,v:points}] : []),
            {k:l.scans,v:state?.receiptCount || 0},
            {k:l.attempts_label,v:state?.pitStop?.attempts || 0},
          ].map((s,i)=>(
            <div key={i} style={{ flex:1, background:"rgba(0,0,0,.28)", borderRadius:"var(--r-lg)", padding:"12px 8px", textAlign:"center" }}>
              <div style={{ fontFamily:"var(--font-display)", fontWeight:900, fontSize:24, color:"#fff" }}>{s.v}</div>
              <div style={{ fontFamily:"var(--font-body)", fontSize:11, fontWeight:700, textTransform:"uppercase", letterSpacing:"0.06em", color:"rgba(255,255,255,.7)" }}>{s.k}</div>
            </div>
          ))}
        </div>
      </div>

      <div style={{ padding:"14px 16px 24px" }}>
        <HintLine text={l.hint_cab} style={{ marginTop:0, marginBottom:12 }} />
        <div style={{ borderRadius:"var(--r-xl)", overflow:"hidden", border:"1px solid var(--border-subtle)" }}>
          {rows.map((r,i)=>(
            <button key={r.actionId} data-ui-action={r.actionId} onClick={r.go} style={{ width:"100%", border:"none", borderBottom:"1px solid var(--border-subtle)", background:"var(--surface-card)", cursor:"pointer", padding:"15px 16px", display:"flex", alignItems:"center", gap:14 }}>
              <Icon name={r.icon} size={20} color="var(--text-muted)" />
              <span style={{ flex:1, textAlign:"left", fontFamily:"var(--font-body)", fontSize:15, fontWeight:600, color:"var(--text-strong)" }}>{r.label}</span>
              {r.sub && <span style={{ fontFamily:"var(--font-body)", fontSize:13, color:"var(--text-muted)" }}>{r.sub}</span>}
              <Icon name="chevron" size={18} color="var(--text-muted)" />
            </button>
          ))}
        </div>
        <button data-ui-action="cabinet:logout" onClick={onLogout} style={{ width:"100%", marginTop:14, background:"transparent", border:"1px solid var(--border-subtle)", borderRadius:"var(--r-lg)", cursor:"pointer", padding:"14px", display:"flex", alignItems:"center", justifyContent:"center", gap:8, color:"var(--text-muted)", fontFamily:"var(--font-heading)", fontSize:14, textTransform:"uppercase" }}>
          <Icon name="logout" size={18} color="var(--text-muted)" />{l.logout}
        </button>
      </div>
    </div>
  );
}

/* ---------- MY CHANCES (codes) ---------- */
function TicketsScreen({ onBack, lang, state, onLoadMore, loadingMore }) {
  const l = L(lang);
  const tickets = Array.isArray(state?.tickets) ? state.tickets : [];
  const total = state?.ticketCount ?? tickets.length;
  const hasMore = !!state?.ticketsHasMore;
  return (
    <div style={{ flex:1, overflowY:"auto", background:"var(--surface-base)", padding:"4px 20px 24px" }}>
      <button data-ui-action="tickets:back" onClick={onBack} style={{ background:"transparent", border:"none", cursor:"pointer", display:"flex", alignItems:"center", gap:8, color:"var(--text-muted)", fontFamily:"var(--font-body)", fontSize:14, padding:"4px 0 10px" }}>
        <Icon name="arrowLeft" size={18} color="var(--text-muted)" />{l.back}
      </button>
      <Eyebrow>{total} {chanceWord(total, lang)} {l.in_game}</Eyebrow>
      <H1>{l.tk_title}</H1>
      <HintLine text={l.hint_tickets} />
      {total === 0 && (
        <div style={{ marginTop:16, borderRadius:"var(--r-xl)", background:"var(--surface-card)", border:"1px solid var(--border-subtle)", padding:"20px" }}>
          <VisualCrop src={approvedKv(lang)} height={150} position="top" style={{ marginBottom:14 }} />
          <div style={{ marginTop:12, fontFamily:"var(--font-heading)", fontSize:17, color:"#fff", textTransform:"uppercase" }}>{l.tk_none}</div>
          <p style={{ margin:"8px 0 16px", fontFamily:"var(--font-body)", fontSize:14, color:"var(--text-muted)", lineHeight:1.45 }}>{withSting(l.tk_empty)}</p>
          <BigButton actionId="tickets:scan" icon="scan" onClick={()=>onBack && onBack("scan")}>{l.scan_receipt}</BigButton>
        </div>
      )}
      <div style={{ marginTop:16, display:"flex", flexDirection:"column", gap:8 }}>
        {tickets.map((t,i)=>(
          <div key={i} style={{ display:"flex", alignItems:"center", gap:13, padding:"14px 16px", borderRadius:"var(--r-lg)", background:"var(--surface-card)", border:"1px solid var(--border-subtle)" }}>
            <Icon name="ticket" size={20} color="var(--brand)" />
            <div style={{ flex:1 }}>
              <div style={{ fontFamily:"var(--font-heading)", fontSize:15, color:"var(--text-strong)", letterSpacing:"0.03em" }}>{t.code}</div>
              <div style={{ fontFamily:"var(--font-body)", fontSize:12, color:"var(--text-muted)", marginTop:2 }}>{t.date || (t.createdAt || "").slice(0,10)} · {t.source || (lang === "uz" ? "chek" : "чек")}</div>
            </div>
            <span style={{ fontFamily:"var(--font-body)", fontSize:11, fontWeight:700, color:"var(--success)", textTransform:"uppercase", letterSpacing:"0.06em" }}>{l.in_game}</span>
          </div>
        ))}
      </div>
      {hasMore && (
        <div style={{ marginTop:16 }}>
          <BigButton actionId="tickets:load_more" icon="chevron" onClick={onLoadMore} disabled={loadingMore}>{l.load_more}</BigButton>
        </div>
      )}
    </div>
  );
}

/* ---------- SCAN (sheet) ---------- */
function normalizedQrValue(value) {
  if (typeof value === "string") return value.trim();
  if (value && typeof value.rawValue === "string") return value.rawValue.trim();
  return "";
}

function telegramScanWebApp() {
  return window.Telegram && window.Telegram.WebApp ? window.Telegram.WebApp : null;
}

function telegramQrPopupSupported(tg) {
  if (!tg || typeof tg.showScanQrPopup !== "function") return false;
  if (typeof tg.isVersionAtLeast === "function") return tg.isVersionAtLeast("6.4");
  const version = String(tg.version || "0.0").split(".").map((part) => Number(part) || 0);
  return version[0] > 6 || (version[0] === 6 && version[1] >= 4);
}

function openTelegramQrScanner(onScan, text, onClosed) {
  const tg = telegramScanWebApp();
  if (!telegramQrPopupSupported(tg)) return null;
  const canListen = typeof tg.onEvent === "function" && typeof tg.offEvent === "function";
  let scanned = false;
  const handleClosed = () => {
    canListen && tg.offEvent("scanQrPopupClosed", handleClosed);
    if (!scanned) onClosed && onClosed();
  };
  canListen && tg.onEvent("scanQrPopupClosed", handleClosed);
  try {
    tg.showScanQrPopup({ text }, (value) => {
      const qrUrl = normalizedQrValue(value);
      if (!qrUrl) return false;
      scanned = true;
      onScan(qrUrl);
      return true;
    });
  } catch {
    canListen && tg.offEvent("scanQrPopupClosed", handleClosed);
    return null;
  }
  return () => {
    canListen && tg.offEvent("scanQrPopupClosed", handleClosed);
  };
}

async function openBarcodeDetectorScanner(video, onScan, onFallback, onPermissionRequested, onPermissionResult) {
  if (!("BarcodeDetector" in window) || !navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) return null;
  onPermissionRequested && onPermissionRequested();
  let stream;
  try {
    stream = await navigator.mediaDevices.getUserMedia({
      audio: false,
      video: { facingMode: { ideal: "environment" } },
    });
  } catch (error) {
    onPermissionResult && onPermissionResult(error && error.name === "NotAllowedError" ? "denied" : "error");
    throw error;
  }
  onPermissionResult && onPermissionResult("granted");
  video.srcObject = stream;
  video.muted = true;
  video.playsInline = true;
  await video.play();
  const detector = new window.BarcodeDetector({ formats: ["qr_code"] });
  let active = true;
  let timer = 0;
  const stop = () => {
    active = false;
    if (timer) window.clearTimeout(timer);
    stream.getTracks().forEach((track) => track.stop());
    video.srcObject = null;
  };
  const detect = async () => {
    if (!active) return;
    try {
      const codes = await detector.detect(video);
      const qrUrl = normalizedQrValue(codes && codes[0]);
      if (qrUrl) {
        stop();
        onScan(qrUrl);
        return;
      }
    } catch {
      stop();
      onFallback && onFallback();
      return;
    }
    timer = window.setTimeout(detect, 300);
  };
  timer = window.setTimeout(detect, 200);
  return stop;
}

function ScanScreen({
  onClose,
  onReward,
  lang,
  disabled,
  onCameraPermissionRequested,
  onCameraPermissionResult,
  onQrDetected,
}) {
  const l = L(lang);
  const [code,setCode] = React.useState("");
  const [scanMode,setScanMode] = React.useState("manual");
  const videoRef = React.useRef(null);
  const stopScannerRef = React.useRef(null);
  const submitQr = React.useCallback((value, source = "manual") => {
    if (disabled) return;
    const qrUrl = normalizedQrValue(value);
    if (!qrUrl) return;
    stopScannerRef.current && stopScannerRef.current();
    stopScannerRef.current = null;
    onQrDetected && onQrDetected(source, qrUrl);
    onReward(qrUrl);
  }, [disabled, onReward, onQrDetected]);
  // The scanner effect must depend on `disabled` alone: parent re-renders make
  // submitQr/l.scan_aim unstable, and every dep change closes and reopens the
  // Telegram QR sheet (the "popup blinks once a second" production incident).
  const submitQrRef = React.useRef(submitQr);
  submitQrRef.current = submitQr;
  const scanAimRef = React.useRef(l.scan_aim);
  scanAimRef.current = l.scan_aim;

  React.useEffect(() => {
    if (disabled) {
      stopScannerRef.current && stopScannerRef.current();
      stopScannerRef.current = null;
      setScanMode("manual");
      return undefined;
    }
    let live = true;
    let startedCamera = false;
    async function startCameraScanner() {
      if (!live || startedCamera) return;
      startedCamera = true;
      const video = videoRef.current;
      if (!video) return;
      if (!("BarcodeDetector" in window) || !navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
        live && setScanMode("manual");
        return;
      }
      live && setScanMode("camera");
      try {
        const stop = await openBarcodeDetectorScanner(
          video,
          (value) => submitQrRef.current(value, "camera"),
          () => live && setScanMode("manual"),
          onCameraPermissionRequested,
          onCameraPermissionResult,
        );
        if (!live) {
          stop && stop();
          return;
        }
        stopScannerRef.current = stop;
        if (!stop) setScanMode("manual");
      } catch {
        live && setScanMode("manual");
      }
    }
    function startScanner() {
      const closeTelegram = openTelegramQrScanner((value) => submitQrRef.current(value, "telegram"), scanAimRef.current, () => {
        if (!live) return;
        stopScannerRef.current = null;
        startCameraScanner();
      });
      if (closeTelegram) {
        live && setScanMode("telegram");
        stopScannerRef.current = closeTelegram;
        return;
      }
      startCameraScanner();
    }
    startScanner();
    return () => {
      live = false;
      stopScannerRef.current && stopScannerRef.current();
      stopScannerRef.current = null;
      const tg = telegramScanWebApp();
      tg && telegramQrPopupSupported(tg) && typeof tg.closeScanQrPopup === "function" && tg.closeScanQrPopup();
    };
  }, [disabled]);

  const scanStatus = scanMode === "telegram" ? l.scan_telegram : scanMode === "camera" ? l.scan_camera : l.scan_auto;
  return (
    <div style={{ flex:1, display:"flex", flexDirection:"column", background:"var(--surface-base)" }}>
      <div style={{ display:"flex", alignItems:"center", gap:14, padding:"6px 20px 10px" }}>
        <button data-ui-action="scan:close" onClick={onClose} style={{ background:"var(--ink-700)", border:"1px solid var(--border-subtle)", borderRadius:"50%", width:40, height:40, display:"flex", alignItems:"center", justifyContent:"center", cursor:"pointer" }}><Icon name="arrowLeft" size={20} color="var(--text-strong)" /></button>
        <H1 size={24}>{l.scan_title}</H1>
      </div>
      <div style={{ margin:"0 20px", display:"flex", alignItems:"center", gap:10, padding:"10px 14px", borderRadius:"var(--r-lg)", background:"rgba(245,197,66,.1)", border:"1px solid var(--sting-gold)" }}>
        <Icon name="qr" size={20} color="var(--sting-gold)" />
        <div>
          <div style={{ fontFamily:"var(--font-heading)", fontSize:13, color:"var(--sting-gold)", lineHeight:1.2 }}>{l.scan_qr_only}</div>
          <div style={{ fontFamily:"var(--font-body)", fontSize:11, color:"var(--text-muted)", marginTop:2 }}>{l.scan_qr_warn}</div>
        </div>
      </div>
      <div style={{ margin:"10px 20px 0", borderRadius:"var(--r-xl)", overflow:"hidden", position:"relative", aspectRatio:"1/1", background:"var(--ink-800)", border:"1px solid var(--border-subtle)" }}>
        <video ref={videoRef} aria-hidden="true" style={{ position:"absolute", inset:0, width:"100%", height:"100%", objectFit:"cover", opacity:scanMode==="camera"?0.74:0, transition:"opacity .18s" }} />
        <div style={{ position:"absolute", inset:"15%", borderRadius:"var(--r-lg)", boxShadow:"0 0 0 2px var(--brand)" }}>
          {["tl","tr","bl","br"].map((c)=>{
            const pos={ tl:{top:-3,left:-3,borderRight:0,borderBottom:0}, tr:{top:-3,right:-3,borderLeft:0,borderBottom:0}, bl:{bottom:-3,left:-3,borderRight:0,borderTop:0}, br:{bottom:-3,right:-3,borderLeft:0,borderTop:0} }[c];
            return <span key={c} style={Object.assign({ position:"absolute", width:26, height:26, border:"3px solid var(--sting-gold)", borderRadius:4 }, pos)} />;
          })}
          <div style={{ position:"absolute", left:0, right:0, top:0, height:2, background:"var(--brand)", boxShadow:"0 0 12px 2px var(--brand-glow)" }} />
        </div>
        {scanMode !== "camera" && <Icon name="qr" size={54} color="var(--ink-500)" style={{ position:"absolute", left:"50%", top:"50%", transform:"translate(-50%,-50%)" }} />}
        <div style={{ position:"absolute", bottom:14, left:0, right:0, textAlign:"center", fontFamily:"var(--font-body)", fontSize:12, color:"var(--text-muted)", padding:"0 16px", boxSizing:"border-box" }}>{scanStatus}</div>
      </div>
      <div style={{ padding:20, display:"flex", flexDirection:"column", gap:14, flex:1 }}>
        <div>
          <div style={{ fontFamily:"var(--font-body)", fontSize:12, color:"var(--text-muted)", marginBottom:7 }}>{l.scan_manual}</div>
          <input data-ui-action="scan:manual_value" readOnly={!!disabled} aria-disabled={disabled ? "true" : "false"} value={code} onChange={(e)=>setCode(e.target.value)} placeholder="https://ofd.soliq.uz/check?..." style={{ width:"100%", boxSizing:"border-box", background:"var(--ink-800)", border:"1px solid var(--border-subtle)", borderRadius:"var(--r-md)", padding:"14px 16px", color:"#fff", fontFamily:"var(--font-heading)", fontSize:16, letterSpacing:"0.05em", outline:"none", opacity:disabled ? .72 : 1 }} />
        </div>
        <div style={{ flex:1 }} />
        <BigButton actionId="scan:submit_manual" icon="bolt" onClick={()=>submitQr(code)} disabled={disabled}>{l.scan_btn}</BigButton>
      </div>
    </div>
  );
}
function RewardOverlay({ onClose, onPlay, onInvite, lang, reward, state }) {
  const l = L(lang);
  const cardRef = React.useRef(null);
  React.useEffect(() => { Snd.playBrand(); J.receiptAccept(cardRef.current); }, []); // always post-gesture: the user just submitted the scan
  const accepted = reward?.accepted ?? 1;
  const raw = reward?.rawCans ?? accepted;
  const attempts = reward?.attemptsAdded ?? accepted;
  const totalAttempts = state?.pitStop?.attempts ?? attempts;
  const win = state?.pitStop?.window;
  const now = Date.parse(state?.pitStop?.serverNow || "");
  const live = Boolean(win && now >= Date.parse(win.startsAt) && now < Date.parse(win.endsAt));
  const capped = reward?.capped;
  return (
    <div className="ovl-in" style={{ position:"absolute", inset:0, zIndex:60, background:"var(--surface-overlay)", backdropFilter:"blur(8px)", WebkitBackdropFilter:"blur(8px)", display:"flex", alignItems:"center", justifyContent:"center", padding:26 }}>
      <div ref={cardRef} style={{ width:"100%", background:"var(--surface-card)", border:"1px solid var(--border-subtle)", borderRadius:"var(--r-xl)", padding:26, textAlign:"center" }}>
        <img src={approvedKv(lang, "square")} alt="" aria-hidden="true" loading="lazy" style={{ width:112, height:112, borderRadius:"var(--r-lg)", objectFit:"cover", objectPosition:"top", display:"block", margin:"0 auto 16px", boxShadow:"var(--shadow-brand)" }} />
        <Eyebrow color="var(--sting-gold)">{l.accepted}</Eyebrow>
        <div style={{ fontFamily:"var(--font-display)", fontWeight:900, fontSize:34, color:"#fff", textTransform:"uppercase", margin:"8px 0 4px" }}>+{accepted} {chanceWord(accepted, lang)}</div>
        <p style={{ fontFamily:"var(--font-body)", fontSize:14, color:"var(--text-muted)", margin:"0 0 6px" }}>{lang === "uz" ? "shaxsiy imkoniyatlar" : "личные шансы"} · +{attempts} {lang === "uz" ? "mini-oʼyin urinishi" : "попытка в мини-игре"}</p>
        <p style={{ fontFamily:"var(--font-heading)", fontSize:13, color:"#fff", margin:"0 0 10px", textTransform:"uppercase" }}>{lang === "uz" ? `Jami: ${totalAttempts} ta urinish` : `Всего: ${totalAttempts} попыток`}</p>
        <p style={{ fontFamily:"var(--font-body)", fontSize:12, color:capped?"var(--sting-gold)":"var(--text-muted)", margin:"0 0 20px" }}>{withSting(capped ? (lang === "uz" ? `Chekda ${raw}, koʻpi bilan 5 tasi hisobga olindi.` : `В чеке ${raw}, зачли максимум 5.`) : l.limits)}</p>
        {live && <div style={{ marginBottom:10 }}><BigButton actionId="game:play" icon="flag" onClick={onPlay}>{l.play_now}</BigButton></div>}
        <button data-ui-action="reward:invite" onClick={onInvite} style={{ width:"100%", height:50, border:"1px solid var(--sting-gold)", borderRadius:"var(--r-lg)", background:"transparent", color:"var(--sting-gold)", fontFamily:"var(--font-heading)", textTransform:"uppercase", marginBottom:8 }}>{l.invite_friends_cta}</button>
        <button data-ui-action="reward:close" onClick={onClose} style={{ width:"100%", height:42, border:0, background:"transparent", color:"var(--text-muted)", fontFamily:"var(--font-body)" }}>{l.continue}</button>
      </div>
    </div>
  );
}

/* ---------- MINI GAME (imperative, ported) ---------- */
const SPOTS = [
  { id:"jackF", labelKey:"pit_jack", x:160, y:34 },
  { id:"jackR", labelKey:"pit_jack", x:160, y:524 },
  { id:"gunFL", labelKey:"pit_nut", x:38, y:189, wheel:"FL" },
  { id:"gunFR", labelKey:"pit_nut", x:282, y:189, wheel:"FR" },
  { id:"gunRL", labelKey:"pit_nut", x:38, y:387, wheel:"RL" },
  { id:"gunRR", labelKey:"pit_nut", x:282, y:387, wheel:"RR" },
  { id:"whFL", labelKey:"pit_wheel", x:64, y:112, wheel:"FL", fresh:true },
  { id:"whFR", labelKey:"pit_wheel", x:256, y:112, wheel:"FR", fresh:true },
  { id:"whRL", labelKey:"pit_wheel", x:64, y:466, wheel:"RL", fresh:true },
  { id:"whRR", labelKey:"pit_wheel", x:256, y:466, wheel:"RR", fresh:true },
];
const MAX_GAME_SESSION_TAPS = 384;
const MAX_GAME_TRACE_EVENTS = 30;
function PitStopGame({ onFinish, onExit, onSessionComplete, lang, challenge }) {
  const l = React.useMemo(()=>L(lang), [lang]);
  const onFinishRef = React.useRef(onFinish);
  const onExitRef = React.useRef(onExit);
  const onSessionCompleteRef = React.useRef(onSessionComplete);
  const abortRef = React.useRef(() => {});
  React.useEffect(()=>{ onFinishRef.current = onFinish; }, [onFinish]);
  React.useEffect(()=>{ onExitRef.current = onExit; }, [onExit]);
  React.useEffect(()=>{ onSessionCompleteRef.current = onSessionComplete; }, [onSessionComplete]);
  const ref = React.useRef(null);
  React.useEffect(()=>{
    const tg = window.Telegram && window.Telegram.WebApp;
    tg?.disableVerticalSwipes?.();
    tg?.enableClosingConfirmation?.();
    return ()=>{
      tg?.enableVerticalSwipes?.();
      tg?.disableClosingConfirmation?.();
    };
  },[]);
  React.useEffect(()=>{
    const root = ref.current;
    const NS = "http://www.w3.org/2000/svg";
    const $ = (s) => root.querySelector(s);
    const nodes = $("#pnodes"), clock = $("#pclock"), phase = $("#pphase"), fin = $("#pfin"), lights = root.querySelectorAll(".lite");
    const stage = $("#pstage"), car = $("#pcar");
    const WINDOW = challenge?.targetWindowMs || 1150, PEN_MISS = 1000, PEN_WILD = 300;
    const fmt = (ms) => (ms/1000).toFixed(2);
    const rnd = (a,b)=>a+Math.random()*(b-a);
    const timers = new Set();
    const after = (fn,ms)=>{ const t=setTimeout(()=>{ timers.delete(t); fn(); }, ms); timers.add(t); return t; };
    let raf = 0, dead = false;
    const configuredQueue = Array.isArray(challenge?.sequence)
      ? challenge.sequence.flatMap((id)=>{ const spot=SPOTS.find((item)=>item.id===id); return spot ? [spot] : []; })
      : [];
    const G = {
      queue:configuredQueue.length===SPOTS.length ? configuredQueue : [...SPOTS].sort(()=>Math.random()-0.5),
      delays:Array.isArray(challenge?.delaysMs) && challenge.delaysMs.length===SPOTS.length ? challenge.delaysMs : [350,...Array(9).fill(250)],
      idx:-1, cur:null, hits:0, streak:0, pen:0, t0:0, captureT0:performance.now(), state:"lights", win:null, events:[], tapTimestampsMs:[],
    };
    const sessionDetail = (status, endedReason) => ({
      status,
      endedReason,
      challengeId: challenge?.challengeId || null,
      events: G.events,
      tapTimestampsMs: G.tapTimestampsMs,
    });
    const abort = (endedReason = "user_exit") => {
      if (dead || G.state === "done" || G.state === "aborted") return;
      G.state = "aborted";
      clearTimeout(G.win);
      cancelAnimationFrame(raf);
      onExitRef.current(sessionDetail("aborted", endedReason));
    };
    const onPageHide = () => abort("page_hidden");
    window.addEventListener("pagehide", onPageHide);
    abortRef.current = abort;
    // each spot kind sounds like its tool; streak drives the pitch progression
    const TOOL_OF = { pit_nut:"nut", pit_wheel:"wheel", pit_jack:"jack" };
    Snd.warmTools(["nut","wheel","jack","miss","expire","rev"]); // render synth voices during the lights, off the tap path
    // client px -> viewBox user coords, for effects at arbitrary tap points
    const toSvg = (e)=>{ const r=car.getBoundingClientRect(); return { x:(e.clientX-r.left)/r.width*320, y:(e.clientY-r.top)/r.height*560 }; };
    const clampX = (x)=>Math.max(45, Math.min(275, x));
    const penText = (ms)=>`+${(ms/1000).toFixed(1)} ${l.sec}`;

    SPOTS.forEach((s)=>{
      const g = document.createElementNS(NS,"g");
      g.setAttribute("class","posnode"); g.setAttribute("data-id",s.id);
      g.innerHTML = `<circle class="hit" cx="${s.x}" cy="${s.y}" r="30"/><circle class="c" cx="${s.x}" cy="${s.y}" r="13"/><text x="${s.x}" y="${s.y+33}">${l[s.labelKey]}</text>`;
      nodes.appendChild(g);
    });
    const paintWheel = (s)=>{ if(!s.wheel) return; const w=$("#wh"+s.wheel); if(!w) return; w.setAttribute("fill", s.fresh ? "#D62300" : "#2a0608"); };
    const addPen = (ms)=>{ G.pen+=ms; clock.classList.remove("pen"); void clock.offsetWidth; clock.classList.add("pen"); };

    // start lights
    lights.forEach((li,i)=> after(()=>{ li.classList.add("on"); Snd.beep(440, 0.08); }, 320*i+250));
    after(()=>{
      if(dead) return;
      lights.forEach((li)=>li.classList.remove("on"));
      Snd.beep(880, 0.15);
      Hx.impact("medium");
      G.state="play"; G.t0=performance.now(); phase.textContent=l.pit_work;
      const tick=()=>{ if(dead||G.state!=="play") return; clock.textContent=fmt(performance.now()-G.t0+G.pen); raf=requestAnimationFrame(tick); };
      tick(); next();
    }, challenge?.readyAfterMs || (320*5+rnd(600,1300)));

    function next(){
      G.idx++;
      if(G.idx>=G.queue.length){ finish(); return; }
      after(()=>{
        if(dead||G.state!=="play") return;
        const s=G.queue[G.idx]; G.cur=s;
        const n=nodes.querySelector('[data-id="'+s.id+'"]'); n.classList.add("active");
        G.win=after(()=>{
          if(dead||G.cur!==s) return;
          G.events.push({ type:"target_miss", sequence:G.idx, targetId:s.id, atMs:Math.round(performance.now()-G.t0) });
          n.classList.remove("active"); n.classList.add("miss"); G.cur=null; G.streak=0;
          Hx.notify("error"); Snd.playTool("expire"); J.expire(n.querySelector(".c"));
          J.floatPenalty(nodes, clampX(s.x), s.y, penText(PEN_MISS));
          addPen(PEN_MISS); next();
        }, WINDOW);
      }, G.delays[G.idx]);
    }
    function onDown(e){
      G.tapTimestampsMs.push(Math.max(0, Math.round(performance.now()-G.captureT0)));
      if(G.tapTimestampsMs.length>=MAX_GAME_SESSION_TAPS){ abort("tap_limit"); return; }
      if(G.state==="lights"){ Snd.playTool("rev"); J.rev(car); return; } // idle tap = engine twitch, no penalty
      if(G.state!=="play") return;
      const node = e.target.closest && e.target.closest(".posnode");
      if(node && G.cur && node.getAttribute("data-id")===G.cur.id){
        Hx.impact("light");
        Snd.playTool(TOOL_OF[G.cur.labelKey] || "nut", G.streak);
        G.streak++;
        J.hit(stage, car, nodes, G.cur.x, G.cur.y, G.streak>=7?2:G.streak>=4?1:0);
        clearTimeout(G.win); const s=G.cur; G.cur=null; G.hits++;
        G.events.push({ type:"target_hit", sequence:G.idx, targetId:s.id, atMs:Math.round(performance.now()-G.t0) });
        node.classList.remove("active"); node.classList.add("done"); paintWheel(s); next();
      } else {
        const remainingTargetOutcomes = G.queue.length-G.idx;
        if(G.events.length>=MAX_GAME_TRACE_EVENTS-remainingTargetOutcomes){ abort("trace_limit"); return; }
        G.events.push({ type:"wild_tap", atMs:Math.round(performance.now()-G.t0) });
        G.streak=0;
        Hx.notify("error"); Snd.playTool("miss"); J.missTap(stage, car); addPen(PEN_WILD);
        const p=toSvg(e); J.floatPenalty(nodes, clampX(p.x), p.y, penText(PEN_WILD));
      }
    }
    root.querySelector("#pstage").addEventListener("pointerdown", onDown);
    function finish(){
      G.state="done"; cancelAnimationFrame(raf);
      Snd.playBrand();
      Hx.notify("success");
      const total = performance.now()-G.t0+G.pen;
      phase.textContent=l.pit_gone; clock.textContent=fmt(total);
      $("#pfinMs").textContent=fmt(total);
      $("#pfinDet").textContent=`${l.dots} ${G.hits}/10`+(G.pen?` · +${(G.pen/1000).toFixed(1)} ${l.sec}`:"");
      fin.style.display="flex";
      const detail = { status:"finished", endedReason:"completed", hits:G.hits, pen:G.pen, challengeId:challenge?.challengeId || null, events:G.events, tapTimestampsMs:G.tapTimestampsMs };
      onSessionCompleteRef.current?.(detail);
      after(()=> onFinishRef.current(total, detail), 1900);
    }
    return ()=>{
      window.removeEventListener("pagehide", onPageHide);
      if (!dead && G.state !== "done" && G.state !== "aborted") {
        G.state = "aborted";
        onExitRef.current(sessionDetail("aborted", "component_unmounted"));
      }
      dead=true;
      timers.forEach(clearTimeout);
      cancelAnimationFrame(raf);
      if (abortRef.current === abort) abortRef.current = () => {};
    };
  }, [challenge, l]);

  return (
    <div ref={ref} data-pitstop="true" style={{ position:"absolute", inset:0, zIndex:55, display:"flex", flexDirection:"column", background:"var(--surface-base)" }}>
      <div style={{ flex:"none", display:"flex", alignItems:"center", gap:12, padding:"12px 18px 8px", borderBottom:"1px solid var(--border-subtle)" }}>
        <button data-ui-action="pit:exit" onClick={()=>abortRef.current()} style={{ background:"transparent", border:"none", cursor:"pointer" }}><Icon name="arrowLeft" size={22} color="var(--text-muted)" /></button>
        <div id="pphase" style={{ fontFamily:"var(--font-heading)", fontSize:12, letterSpacing:"0.12em", textTransform:"uppercase", color:"var(--brand)" }}>{l.pit_ready}</div>
        <div id="pclock" className="pclock" style={{ marginLeft:"auto", fontFamily:"var(--font-display)", fontWeight:900, fontSize:26, color:"#fff" }}>0.00</div>
      </div>
      <div id="pstage" style={{ flex:1, position:"relative", display:"flex", alignItems:"center", justifyContent:"center", overflow:"hidden", touchAction:"manipulation" }}>
        <div style={{ position:"absolute", top:10, left:"50%", transform:"translateX(-50%)", display:"flex", gap:8, zIndex:2 }}>
          {[0,1,2,3,4].map(i=><span key={i} className="lite" />)}
        </div>
        <svg id="pcar" viewBox="0 0 320 560" style={{ height:"100%", maxHeight:"100%", width:"auto", maxWidth:"96%" }}>
          <rect x="36" y="22" width="248" height="516" fill="none" stroke="#2a2a32" strokeWidth="2" strokeDasharray="10 8" rx="10"/>
          <image href={BOLID} x="0" y="0" width="320" height="560" preserveAspectRatio="xMidYMid meet" style={{ pointerEvents:"none" }}/>
          <g id="pnodes"></g>
        </svg>
        <div id="pfin" style={{ display:"none", position:"absolute", inset:0, zIndex:3, flexDirection:"column", alignItems:"center", justifyContent:"center", gap:8, background:"radial-gradient(circle at 50% 45%, #ff2b33, #a3000a 80%)" }}>
          <div id="pfinMs" style={{ fontFamily:"var(--font-display)", fontWeight:900, fontSize:64, color:"#fff" }}>0.00</div>
          <div style={{ fontFamily:"var(--font-heading)", fontSize:14, color:"#fff", textTransform:"uppercase", letterSpacing:"0.1em" }}>{l.pit_gone}</div>
          <div id="pfinDet" style={{ fontFamily:"var(--font-body)", fontSize:13, color:"#ffd9da" }} />
        </div>
      </div>
      <div style={{ flex:"none", padding:"12px 18px calc(16px + env(safe-area-inset-bottom))", textAlign:"center", fontFamily:"var(--font-body)", fontSize:13, color:"var(--text-muted)" }}>{l.pit_hint}</div>
    </div>
  );
}

/* ---------- RESULTS ---------- */
function ResultsScreen({ result, state, onClose, onInvite, onStory, storySharing, lang }) {
  const l = L(lang);
  const my = result ? result.time : 7820;
  const youId = state?.user?.id;
  // fresh state already contains today's leaderboard (incl. this finish)
  let rows = [...(state?.pitStop?.results || [])].sort((a, b) => a.elapsedMs - b.elapsedMs);
  if (!rows.some((r) => r.userId === youId)) {
    rows = [...rows, {
      userId: youId,
      name: l.you,
      elapsedMs: my,
      points: result?.backend?.points || 0,
      multiplier: result?.backend?.multiplier || 1,
    }].sort((a, b) => a.elapsedMs - b.elapsedMs);
  }
  const own = rows.find((r) => r.userId === youId);
  const x2 = (own?.multiplier || 1) > 1;
  React.useEffect(() => {
    if (!x2) return undefined;
    Hx.impact("heavy");
    J.confettiBurst(0.5, 0.4); // team boost is a session-level peak, confetti earns its bytes here
    const t = window.setTimeout(() => Hx.impact("heavy"), 140);
    return () => window.clearTimeout(t);
  }, [x2]);
  const played = state?.team?.playedCount || 0;
  const attempts = state?.pitStop?.attempts || 0;
  const showPoints = state?.currentTour?.mechanics?.showPoints ?? true;
  return (
    <div className="ovl-in" style={{ position:"absolute", inset:0, zIndex:60, background:"var(--surface-overlay)", backdropFilter:"blur(8px)", WebkitBackdropFilter:"blur(8px)", display:"flex", alignItems:"center", justifyContent:"center", padding:22 }}>
      <div style={{ width:"100%", background:"var(--surface-card)", border:"1px solid var(--border-subtle)", borderRadius:"var(--r-xl)", padding:22 }}>
        <Eyebrow color="var(--sting-gold)">{l.ride_counted}</Eyebrow>
        <div style={{ display:"flex", alignItems:"baseline", gap:10, margin:"6px 0 4px" }}>
          <div style={{ fontFamily:"var(--font-display)", fontWeight:900, fontSize:44, color:"#fff" }}>{(my/1000).toFixed(2)}</div>
          <div style={{ fontFamily:"var(--font-heading)", fontSize:13, color:"var(--text-muted)", textTransform:"uppercase" }}>{l.sec} {x2 && "· "} {x2 && <span style={{ color:"var(--sting-gold)" }}>{l.x2}</span>}</div>
        </div>
        {result && <div style={{ fontFamily:"var(--font-body)", fontSize:12, color:"var(--text-muted)", marginBottom:12 }}>{l.dots} {result.hits}/10{result.pen?` · ${l.penalties} +${(result.pen/1000).toFixed(1)} ${l.sec}`:""}</div>}
        {showPoints && (
          <div style={{ fontFamily:"var(--font-heading)", fontSize:16, color:"var(--sting-gold)", marginBottom:10, textTransform:"uppercase" }}>
            {l.you_got} +{own?.points || 0} {l.points_gen}
          </div>
        )}
        <div style={{ borderTop:"1px solid var(--border-subtle)", paddingTop:10 }}>
          <LeaderboardTable rows={rows.slice(0, 6)} youId={youId} l={l} showPoints={showPoints} />
        </div>
        {!x2 && state?.team && (
          <div style={{ marginTop:10, fontFamily:"var(--font-body)", fontSize:11, lineHeight:1.4, color:"var(--text-muted)" }}>{l.x2_note}</div>
        )}
        {!showPoints && (
          <div style={{ margin:"12px 0", padding:"12px 14px", borderRadius:"var(--r-lg)", background:"rgba(245,197,66,.1)", fontFamily:"var(--font-body)", fontSize:13, lineHeight:1.45, color:"var(--text-body)" }}>
            <b style={{ color:"var(--sting-gold)" }}>{state?.team?.boostActive ? "x2" : teamBoostProgress(state?.team).text}</b>
            {" · "}{l.game_no_chance}
            <div style={{ marginTop:6 }}>{lang === "uz" ? `Qolgan urinishlar: ${attempts}.` : `Осталось попыток: ${attempts}.`} {l.attempts_saved}</div>
          </div>
        )}
        <div style={{ marginBottom:10 }}><BigButton actionId="results:invite" icon="users" onClick={onInvite}>{l.invite_friends_cta}</BigButton></div>
        {storySharing && <div style={{ marginBottom:10 }}><BigButton actionId="results:share_story" icon="share" onClick={onStory}>{l.story_result}</BigButton></div>}
        <button data-ui-action="results:close" onClick={onClose} style={{ width:"100%", height:46, border:"1px solid var(--border-subtle)", borderRadius:"var(--r-lg)", background:"transparent", color:"var(--text-strong)", fontFamily:"var(--font-heading)", textTransform:"uppercase" }}>{l.continue}</button>
      </div>
    </div>
  );
}

function PlayReadyModal({ lang, state, onClose, onPlay, onInvite, onScan, disabled }) {
  const l = L(lang);
  const attempts = state?.pitStop?.attempts || 0;
  const played = Boolean(state?.pitStop?.playedSelf);
  const win = state?.pitStop?.window;
  const nowMs = useNowTicker(Boolean(win), state?.pitStop?.serverNow);
  const live = Boolean(win && phaseOf(win, nowMs) === "live");
  const time = win ? fmtHms(Date.parse(win.endsAt) - nowMs) : "00:00";
  React.useEffect(() => { J.overlayEnter(); }, []);
  return (
    <div className="ovl-in" style={{ position:"absolute", inset:0, zIndex:70, background:"var(--surface-overlay)", display:"flex", alignItems:"center", justifyContent:"center", padding:22 }}>
      <div style={{ width:"100%", background:"var(--surface-card)", border:"1px solid var(--border-subtle)", borderRadius:"var(--r-xl)", padding:22 }}>
        <Eyebrow color="var(--sting-gold)">{l.time_left}: {time}</Eyebrow>
        <H1 size={28}>{played ? l.pit_done : attempts > 0 ? l.ready_title : l.no_attempts_title}</H1>
        <p style={{ fontFamily:"var(--font-body)", fontSize:14, lineHeight:1.5, color:"var(--text-muted)", margin:"12px 0" }}>
          {played
            ? l.pit_done_sub
            : attempts > 0
            ? (lang === "uz" ? `Sizda ${attempts} ta urinish bor. ${l.ready_spend}` : `У вас ${attempts} попыток. ${l.ready_spend}`)
            : l.no_attempts_body}
        </p>
        <p style={{ fontFamily:"var(--font-body)", fontSize:13, lineHeight:1.45, color:"var(--text-body)", margin:"0 0 16px" }}>
          {lang === "uz"
            ? `Bugun jamoadan ${PLAYERS_UZ} oʼynasa, bugungi cheklar imkoniyatlari oʼynagan har bir kishida ikki barobar boʼladi.`
            : `Если сегодня сыграют ${PLAYERS_RU} из команды, шансы с сегодняшних чеков удвоятся у каждого, кто сыграл.`}
        </p>
        {played
          ? null
          : attempts > 0 && live
          ? <div style={{ marginBottom:10 }}><BigButton actionId="game:play" icon="flag" onClick={onPlay} disabled={disabled}>{l.play_now}</BigButton></div>
          : <div style={{ marginBottom:10 }}><BigButton actionId="game:scan_for_attempt" icon="scan" onClick={onScan}>{l.scan_receipt_cta}</BigButton></div>}
        <button data-ui-action="play_ready:invite" onClick={onInvite} style={{ width:"100%", height:50, border:"1px solid var(--sting-gold)", borderRadius:"var(--r-lg)", background:"transparent", color:"var(--sting-gold)", fontFamily:"var(--font-heading)", textTransform:"uppercase" }}>{l.invite_friends_cta}</button>
        <button data-ui-action="play_ready:close" onClick={onClose} style={{ width:"100%", height:42, marginTop:6, border:0, background:"transparent", color:"var(--text-muted)", fontFamily:"var(--font-body)" }}>{l.close}</button>
      </div>
    </div>
  );
}

function TeamManageModal({ lang, state, onClose, onCreate, onLeave, disabled }) {
  const l = L(lang);
  const [name, setName] = React.useState(state?.team?.name || `${state?.user?.name || "STING"} CREW`);
  const hasTeam = Boolean(state?.team);
  React.useEffect(() => { J.overlayEnter(); }, []);
  return (
    <div className="ovl-in" style={{ position:"absolute", inset:0, zIndex:70, background:"var(--surface-overlay)", backdropFilter:"blur(8px)", WebkitBackdropFilter:"blur(8px)", display:"flex", alignItems:"center", justifyContent:"center", padding:22 }}>
      <div style={{ width:"100%", background:"var(--surface-card)", border:"1px solid var(--border-subtle)", borderRadius:"var(--r-xl)", padding:22 }}>
        <Eyebrow color="var(--sting-gold)">{l.important}</Eyebrow>
        <H1 size={26}>{hasTeam ? l.change_team : l.create_team}</H1>
        {hasTeam && (
          <p style={{ fontFamily:"var(--font-body)", fontSize:14, color:"var(--text-muted)", lineHeight:1.45, margin:"10px 0 14px" }}>
            {l.team_keep}
          </p>
        )}
        <input data-ui-action="team:name_input" readOnly={!!disabled} aria-disabled={disabled ? "true" : "false"} value={name} onChange={(e)=>setName(e.target.value)} placeholder={l.team_name_ph} style={{ width:"100%", boxSizing:"border-box", background:"var(--ink-800)", border:"1px solid var(--border-subtle)", borderRadius:"var(--r-md)", padding:"14px 16px", color:"#fff", fontFamily:"var(--font-heading)", fontSize:16, textTransform:"uppercase", outline:"none", margin:"8px 0 14px", opacity:disabled ? .72 : 1 }} />
        <BigButton actionId="team:save" icon="users" onClick={()=>onCreate(name)} disabled={disabled}>{hasTeam ? l.create_new_confirm : l.create_team}</BigButton>
        {hasTeam && (
          <button data-ui-action="team:leave" aria-disabled={disabled ? "true" : "false"} onClick={(event)=>{ if (disabled) { event.preventDefault(); return; } onLeave?.(); }} style={{ width:"100%", marginTop:10, height:46, border:"1px solid var(--border-subtle)", borderRadius:"var(--r-lg)", background:"transparent", color:"var(--sting-gold)", fontFamily:"var(--font-heading)", textTransform:"uppercase", opacity:disabled ? .72 : 1, cursor:disabled ? "not-allowed" : "pointer" }}>
            {l.go_solo}
          </button>
        )}
        <button data-ui-action="team:stay" onClick={onClose} style={{ width:"100%", marginTop:10, height:42, border:"none", background:"transparent", color:"var(--text-muted)", fontFamily:"var(--font-body)" }}>{l.stay}</button>
      </div>
    </div>
  );
}

function ProfileSheet({ lang, state, onClose, onSave, disabled }) {
  const l = L(lang);
  const [displayName, setDisplayName] = React.useState(state?.user?.name || "");
  const [teamName, setTeamName] = React.useState(state?.team?.name || `${state?.user?.name || "STING"} CREW`);
  React.useEffect(() => { J.overlayEnter(); }, []);
  return (
    <div className="sheet-in" style={{ position:"absolute", inset:0, zIndex:70, background:"var(--surface-overlay)", backdropFilter:"blur(8px)", WebkitBackdropFilter:"blur(8px)", display:"flex", alignItems:"flex-end" }}>
      <div style={{ width:"100%", background:"var(--ink-900)", borderTopLeftRadius:"var(--r-xl)", borderTopRightRadius:"var(--r-xl)", borderTop:"1px solid var(--border-subtle)", padding:"22px 20px calc(24px + env(safe-area-inset-bottom))" }}>
        <div style={{ width:40, height:4, borderRadius:2, background:"var(--ink-600)", margin:"0 auto 18px" }} />
        <H1 size={24}>{l.profile}</H1>
        <p style={{ fontFamily:"var(--font-body)", fontSize:13, color:"var(--text-muted)", margin:"8px 0 16px" }}>{l.name_visible}</p>
        <label style={{ display:"block", fontFamily:"var(--font-body)", fontSize:12, color:"var(--text-muted)", marginBottom:6 }}>{l.name_label}</label>
        <input data-ui-action="profile:display_name_input" readOnly={!!disabled} aria-disabled={disabled ? "true" : "false"} value={displayName} onChange={(e)=>setDisplayName(e.target.value)} placeholder={l.name_ph} style={{ width:"100%", boxSizing:"border-box", background:"var(--ink-800)", border:"1px solid var(--border-subtle)", borderRadius:"var(--r-md)", padding:"14px 16px", color:"#fff", fontFamily:"var(--font-heading)", fontSize:16, outline:"none", marginBottom:14, opacity:disabled ? .72 : 1 }} />
        <label style={{ display:"block", fontFamily:"var(--font-body)", fontSize:12, color:"var(--text-muted)", marginBottom:6 }}>{l.team_name_label}</label>
        <input data-ui-action="profile:team_name_input" readOnly={!!disabled} aria-disabled={disabled ? "true" : "false"} value={teamName} onChange={(e)=>setTeamName(e.target.value)} placeholder="STING CREW" style={{ width:"100%", boxSizing:"border-box", background:"var(--ink-800)", border:"1px solid var(--border-subtle)", borderRadius:"var(--r-md)", padding:"14px 16px", color:"#fff", fontFamily:"var(--font-heading)", fontSize:16, textTransform:"uppercase", outline:"none", marginBottom:16, opacity:disabled ? .72 : 1 }} />
        <BigButton actionId="profile:save" icon="check" onClick={()=>onSave(displayName, teamName)} disabled={disabled}>{l.save}</BigButton>
        <button data-ui-action="profile:close" onClick={onClose} style={{ width:"100%", marginTop:10, background:"transparent", border:"none", cursor:"pointer", color:"var(--text-muted)", fontFamily:"var(--font-body)", fontSize:13 }}>{l.close}</button>
      </div>
    </div>
  );
}

/* Rules of the daily mini-game + entry to the practice run (no points, no backend). */
function GameIntroModal({ lang, onClose, onPractice }) {
  const l = L(lang);
  React.useEffect(() => { J.overlayEnter(); }, []);
  return (
    <div className="ovl-in" style={{ position:"absolute", inset:0, zIndex:70, background:"var(--surface-overlay)", backdropFilter:"blur(8px)", WebkitBackdropFilter:"blur(8px)", display:"flex", alignItems:"center", justifyContent:"center", padding:22 }}>
      <div style={{ width:"100%", background:"var(--surface-card)", border:"1px solid var(--border-subtle)", borderRadius:"var(--r-xl)", padding:22 }}>
        <Eyebrow color="var(--sting-gold)">{l.pit_next}</Eyebrow>
        <H1 size={26}>{l.gi_title}</H1>
        {[["clock", l.gi_b1], ["bolt", l.gi_b2], ["users", l.gi_b3]].map(([ic, txt], i)=>(
          <div key={i} style={{ display:"flex", gap:12, marginTop:14 }}>
            <span style={{ width:34, height:34, flex:"none", borderRadius:"var(--r-md)", background:"rgba(214,35,0,.14)", display:"flex", alignItems:"center", justifyContent:"center" }}><Icon name={ic} size={18} color="var(--brand)" /></span>
            <p style={{ margin:0, fontFamily:"var(--font-body)", fontSize:13, lineHeight:1.5, color:"var(--text-body)" }}>{txt}</p>
          </div>
        ))}
        <div style={{ marginTop:18 }}><BigButton actionId="game:practice" icon="flag" onClick={onPractice}>{l.gi_cta}</BigButton></div>
        <button data-ui-action="game_intro:close" onClick={onClose} style={{ width:"100%", marginTop:10, background:"transparent", border:"none", cursor:"pointer", color:"var(--text-muted)", fontFamily:"var(--font-body)", fontSize:13 }}>{l.close}</button>
      </div>
    </div>
  );
}

function InviteModal({ invite, onClose, onStory, storySharing, lang }) {
  const l = L(lang);
  const sent = invite?.botDelivery?.sent;
  React.useEffect(() => { J.overlayEnter(); }, []);
  return (
    <div className="ovl-in" style={{ position:"absolute", inset:0, zIndex:70, background:"var(--surface-overlay)", backdropFilter:"blur(8px)", WebkitBackdropFilter:"blur(8px)", display:"flex", alignItems:"center", justifyContent:"center", padding:22 }}>
      <div style={{ width:"100%", background:"var(--surface-card)", border:"1px solid var(--border-subtle)", borderRadius:"var(--r-xl)", padding:22 }}>
        <div style={{ height:146, borderRadius:"var(--r-lg)", background:`linear-gradient(90deg, rgba(0,0,0,.72), rgba(0,0,0,.12)), url(${approvedKv(lang)}) center top/cover no-repeat`, border:"1px solid var(--border-subtle)", padding:16, display:"flex", flexDirection:"column", justifyContent:"flex-end", marginBottom:16 }}>
          <div style={{ fontFamily:"var(--font-heading)", fontSize:12, color:"var(--sting-gold)", textTransform:"uppercase" }}>{invite?.teamName}</div>
          <div style={{ fontFamily:"var(--font-display)", fontSize:30, lineHeight:.9, color:"#fff", textTransform:"uppercase" }}>{l.invite_friends}</div>
        </div>
        <H1 size={25}>{l.check_bot}</H1>
        <p style={{ fontFamily:"var(--font-body)", fontSize:14, color:"var(--text-muted)", lineHeight:1.45, margin:"8px 0 10px" }}>
          {sent ? l.invite_sent : l.invite_created}
        </p>
        <div style={{ display:"flex", gap:8, alignItems:"flex-start", padding:"10px 12px", borderRadius:"var(--r-md)", background:"rgba(245,197,66,.1)", border:"1px solid var(--sting-gold)", marginBottom:14 }}>
          <Icon name="gift" size={16} color="var(--sting-gold)" style={{ flex:"0 0 16px", marginTop:1 }} />
          <span style={{ fontFamily:"var(--font-body)", fontSize:12.5, lineHeight:1.4, color:"var(--text-body)" }}>
            {l.invite_benefit}
            {/* v9: each referral stage is promised only when the promo config
                actually pays it (referral.enabled + a non-zero bonus). */}
            {REFERRAL_REWARDS_VISIBLE && (
              <span style={{ display:"block", marginTop:6 }}>
                {REFERRAL.joinAttemptBonus > 0 && `${l.ref_join} `}
                {REFERRAL.firstReceiptTicketBonus > 0 && l.ref_receipt}
              </span>
            )}
          </span>
        </div>
        <div style={{ border:"1px solid var(--border-subtle)", borderRadius:"var(--r-md)", padding:"10px 12px", fontFamily:"var(--font-body)", fontSize:12, color:"var(--text-body)", wordBreak:"break-all", marginBottom:12 }}>{invite?.inviteLink}</div>
        <button data-ui-action="invite:copy_link" onClick={()=>navigator.clipboard?.writeText(invite?.inviteLink || "")} style={{ width:"100%", height:44, border:"1px solid var(--border-subtle)", borderRadius:"var(--r-lg)", background:"transparent", color:"var(--text-strong)", fontFamily:"var(--font-heading)", textTransform:"uppercase", marginBottom:10 }}>{l.copy_link}</button>
        {storySharing && <div style={{ marginBottom:10 }}><BigButton actionId="invite:share_story" icon="share" onClick={onStory}>{l.share_story}</BigButton></div>}
        <BigButton actionId="invite:close" icon="check" onClick={onClose}>{l.ok_got}</BigButton>
      </div>
    </div>
  );
}

function StoryPreviewModal({ story, onClose, onShare, onGesture, canShare, lang }) {
  const l = L(lang);
  const dialogRef = React.useRef(null);
  React.useEffect(() => {
    J.overlayEnter();
    const dialog = dialogRef.current;
    if (dialog && !dialog.open) dialog.showModal();
    return () => { if (dialog?.open) dialog.close(); };
  }, []);
  return (
    <dialog
      ref={dialogRef}
      className="ovl-in story-dialog"
      data-ui-capture="explicit"
      aria-label={l.story_preview}
      onCancel={() => {
        onGesture?.("story:cancel", {});
        onClose();
      }}
    >
      <div className="story-dialog-card">
        <H1 size={25}>{l.story_preview}</H1>
        <img className="story-preview-image" src={story.mediaUrl} alt={l.story_preview} />
        <div className="story-code-row">
          <span style={{ fontFamily:"var(--font-heading)", fontSize:18, color:"var(--sting-gold)", letterSpacing:".06em" }}>{story.fallbackCode}</span>
          <button data-ui-action="story:copy_code" type="button" className="story-code-copy" onClick={()=>navigator.clipboard?.writeText(story.fallbackCode || "")}>{l.story_copy_code}</button>
        </div>
        <p style={{ margin:"0 0 14px", fontFamily:"var(--font-body)", fontSize:12, lineHeight:1.45, color:"var(--text-muted)" }}>{l.story_code_hint}</p>
        <BigButton actionId="story:share" icon="share" onClick={onShare}>{canShare ? l.share_story : l.story_open_png}</BigButton>
        <button data-ui-action="story:close" type="button" className="story-close" onClick={onClose}>{l.close}</button>
      </div>
    </dialog>
  );
}

/* ---------- RULES (how it works, step by step, formal address) ---------- */
/* A good-vs-bad receipt visual: the QR slip is accepted, the terminal slip is not. */
function RulesReceiptCompare({ okLabel, noLabel }) {
  const chip = (ok) => (
    <div style={{ flex:1, display:"flex", flexDirection:"column", alignItems:"center", gap:8 }}>
      <div style={{ position:"relative", width:76, height:96, borderRadius:8, background:"var(--ink-800)", border:`1.5px solid ${ok ? "var(--sting-gold)" : "var(--border-strong)"}`, padding:8, boxSizing:"border-box" }}>
        {[0,1,2].map((i)=>(<div key={i} style={{ height:3, borderRadius:2, background:"var(--ink-500)", margin:"0 4px 5px", width:i===2?"60%":"auto" }} />))}
        {ok
          ? <div style={{ position:"absolute", left:"50%", bottom:8, transform:"translateX(-50%)", width:34, height:34, background:"#fff", borderRadius:3, display:"flex", alignItems:"center", justifyContent:"center" }}><Icon name="qr" size={26} color="#000" /></div>
          : <div style={{ position:"absolute", left:"50%", bottom:14, transform:"translateX(-50%)", fontFamily:"var(--font-body)", fontSize:9, color:"var(--text-muted)", textAlign:"center", lineHeight:1.2 }}>—</div>}
      </div>
      <div style={{ display:"flex", alignItems:"center", gap:5 }}>
        <span style={{ width:18, height:18, borderRadius:"50%", background:ok?"var(--sting-gold)":"var(--brand)", display:"flex", alignItems:"center", justifyContent:"center" }}>
          <Icon name={ok?"check":"plus"} size={12} color={ok?"#000":"#fff"} style={ok?undefined:{ transform:"rotate(45deg)" }} />
        </span>
        <span style={{ fontFamily:"var(--font-heading)", fontSize:11, color:ok?"var(--sting-gold)":"var(--text-muted)" }}>{ok?okLabel:noLabel}</span>
      </div>
    </div>
  );
  return (
    <div style={{ display:"flex", gap:14, margin:"12px 0 2px" }}>{chip(true)}{chip(false)}</div>
  );
}

function RulesScreen({ lang, onBack, onNav, onMiniGame }) {
  const l = L(lang);
  const uz = lang === "uz";
  const T = (ru, uzt) => (uz ? uzt : ru);
  // Client backlog 14.07 (P2-33): three core steps, then an "extra chances"
  // block; no money prizes, no points-to-prizes promises.
  const sections = [
    { icon:"plus", t:T("Шаг 1. Купите Sting","1-qadam. Sting sotib oling"),
      b:T("Купите Sting и сохраните чек с QR-кодом.",
          "Sting sotib oling va QR-kodli chekni saqlang.") },
    { icon:"qr", t:T("Шаг 2. Отсканируйте чек с QR-кодом","2-qadam. QR-kodli chekni skanlang"),
      b:T("Принимается только чек с QR-кодом. Попросите его у продавца и отсканируйте QR-код через Mini App. Чек без QR-кода или чек из терминала не принимается.",
          "Faqat QR-kodli chek qabul qilinadi. Uni sotuvchidan soʼrang va QR-kodni Mini App orqali skanlang. QR-kodsiz yoki terminaldan chiqqan chek qabul qilinmaydi."),
      extra:<RulesReceiptCompare okLabel={T("подходит","mos")} noLabel={T("не подходит","mos emas")} /> },
    { icon:"ticket", t:T("Шаг 3. Участвуйте","3-qadam. Ishtirok eting"),
      b:T("1 Sting = 1 шанс в розыгрыше поездки на двоих и 1 попытка в мини-игре. В одном чеке засчитывается до 5 Sting, в день - до 3 чеков.",
          "1 ta Sting = ikki kishilik sayohat qurʼasida 1 imkoniyat va mini-oʼyinda 1 ta urinish. Bitta chekda 5 tagacha Sting, kuniga 3 tagacha chek hisobga olinadi."),
      action:"scan", actionLabel:T("СКАНИРОВАТЬ ЧЕК","CHEKNI SKANLASH") },
    { heading:T("Доп. шансы","Qoʼshimcha imkoniyatlar") },
    { icon:"bolt", t:T("Мини-игра","Mini-oʼyin"),
      b:T("Раз в день бот пришлёт вам приглашение на игру. Играть можно в любое время до конца дня. Жмите кнопки на скорость - обслужите болид быстрее.",
          "Kuniga bir marta bot Sizga oʼyinga taklif yuboradi. Kun oxirigacha istalgan vaqtda oʼynashingiz mumkin. Tugmalarni tez bosing - bolidga tezroq xizmat koʼrsating."),
      action:"miniGame", actionLabel:T("ПОПРОБОВАТЬ МИНИ-ИГРУ","MINI-OʼYINNI SINAB KOʼRISH") },
    { icon:"users", t:T("Команда: шансы ×2","Jamoa: imkoniyatlar ×2"),
      b:T(`Соберите команду. Если за день сыграют ${PLAYERS_RU} из команды - шансы с чеков этого дня удваиваются у каждого, кто сыграл. Зовите друзей играть вместе.`,
          `Jamoa tuzing. Bir kunda jamoadan ${PLAYERS_UZ} oʼynasa - oʼsha kungi cheklar imkoniyatlari oʼynagan har bir kishida ikki barobar boʼladi. Doʼstlaringizni birga oʼynashga chaqiring.`) },
  ];
  return (
    <div style={{ flex:1, display:"flex", flexDirection:"column", background:"var(--surface-base)", overflow:"hidden" }}>
      <div style={{ display:"flex", alignItems:"center", gap:14, padding:"6px 20px 10px", flex:"none" }}>
        <button data-ui-action="rules:back" type="button" aria-label={l.back} onClick={onBack} style={{ background:"var(--ink-700)", border:"1px solid var(--border-subtle)", borderRadius:"50%", width:40, height:40, display:"flex", alignItems:"center", justifyContent:"center", cursor:"pointer" }}><Icon name="arrowLeft" size={20} color="var(--text-strong)" /></button>
        <H1 size={24}>{l.rules}</H1>
      </div>
      <div style={{ flex:1, overflowY:"auto", padding:"4px 16px 26px", WebkitOverflowScrolling:"touch" }}>
        {sections.map((s, i) => {
          if (s.heading) {
            return (
              <div key={i} style={{ padding:"18px 0 4px", fontFamily:"var(--font-heading)", fontSize:13, letterSpacing:"0.08em", textTransform:"uppercase", color:"var(--sting-gold)" }}>{s.heading}</div>
            );
          }
          const headingIndex = sections.findIndex((x) => x.heading);
          const numbered = i < headingIndex;
          return (
            <div key={i} style={{ display:"flex", gap:14, padding:"14px 0", borderBottom:i<sections.length-1?"1px solid var(--border-subtle)":"none" }}>
              <div style={{ flex:"0 0 44px" }}>
                <div style={{ width:44, height:44, borderRadius:12, background:"var(--surface-card)", border:"1px solid var(--border-subtle)", display:"flex", alignItems:"center", justifyContent:"center", position:"relative" }}>
                  <Icon name={s.icon} size={22} color="var(--brand)" />
                  {numbered && <span style={{ position:"absolute", top:-7, left:-7, width:20, height:20, borderRadius:"50%", background:"var(--sting-gold)", color:"#000", fontFamily:"var(--font-display)", fontWeight:900, fontSize:11, display:"flex", alignItems:"center", justifyContent:"center" }}>{i+1}</span>}
                </div>
              </div>
              <div style={{ flex:1, minWidth:0 }}>
                <div style={{ fontFamily:"var(--font-heading)", fontSize:16, color:"var(--text-strong)", marginBottom:4 }}>{s.t}</div>
                <div style={{ fontFamily:"var(--font-body)", fontSize:13, color:"var(--text-body)", lineHeight:1.5 }}>{s.b}</div>
                {s.extra || null}
                {s.actionLabel && (
                  <div style={{ marginTop:14 }}>
                    <BigButton
                      actionId={s.action === "miniGame" ? "rules:practice_game" : "rules:scan"}
                      icon={s.action === "miniGame" ? "bolt" : "scan"}
                      tone={s.action === "miniGame" ? "gold" : undefined}
                      onClick={s.action === "miniGame" ? onMiniGame : ()=>onNav("scan")}
                    >
                      {s.actionLabel}
                    </BigButton>
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

inject();
export const StingScreens = {
  BottomNav, LoginScreen, HomeScreen, TeamScreen, BakuScreen,
  CabinetScreen, TicketsScreen, ScanScreen, RewardOverlay, PitStopGame, ResultsScreen, PlayReadyModal,
  TeamManageModal, ProfileSheet, InviteModal, StoryPreviewModal, GameIntroModal, RulesScreen,
};
// Shared brand bits reused by the tutorial overlay (tutorial.tsx).
export { ElectricCan, BigButton, Eyebrow, H1, PATTERN };
